var Assessment = {

  delete : function ( id ) {
    popup.generatePopup({
      title: 'Deleting Assessment Record',
      method: 'ajax',
      ajaxUrl: '/AJAX_Cms/delete-record/assessment/' + id,
    });
  },

  showAdd : function() {
    popup.generatePopup({
      title: 'Adding Assessment Record',
      method: 'ajax',
      ajaxUrl: '/AJAX_Cms/add-record/assessment',
      maxWidth: 700,
      success: function() {
        cms.appendOnSaveCallback ( function() {
          popup.close();

          TweenMax.delayedCall ( 5, function() {
            // - SHOW POSITIVE FLASH DATA
            main.flashData.show ( 'Redirecting to new assessment...', 'positive' );
          });

          TweenMax.delayedCall ( 10, function() {
            window.location.href = '/assessment/builder/' + cms.added_id;
          });
        });
      },
    });
  },

  // - subclass
  builder : {

    openTab : 'overview',
    editingAssessmentID : null,
    editingSectionID    : null,
    editingQuestionID   : null,
    editingQuestion     : null,
    ckeditor : {
      configs : {
        multiple_choice_text : {
          height: '80px',

          toolbar : [
            { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
            { name: 'editing', items: [ 'Scayt' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
          ],
        },

        drag_in_the_blank_text : {
          height: '200px',

          contentsCss : '/assets/css/ckeditor-content-css/ditb.css',

          toolbar : [
            { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
            { name: 'editing', items: [ 'Scayt' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'styles', items: [ 'Styles' ] },
            { name: 'document', items: [ 'Source' ] },
          ],
        },

        fill_in_the_blank_text : {
          height: '200px',

          contentsCss : '/assets/css/ckeditor-content-css/fitb.css',

          toolbar : [
            { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
            { name: 'editing', items: [ 'Scayt' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'styles', items: [ 'Styles' ] },
            { name: 'document', items: [ 'Source' ] },
          ],
        },

        instructions : {
          height: '80px',

          toolbar : [
            { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
            { name: 'editing', items: [ 'Scayt' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
          ],
        },
      }
    },

    init : function() {
      // - SHOW AND HIDE CERTAIN TABS
      $('.ab-section').hide();
      $('.ab-overview-settings').show();

      // - ADD NAV TAB EVENTS
      $('.ab-nav a').off ( 'click' );
      $('.ab-nav a').on  ( 'click', function ( evt ) {
        $('.ab-nav li').removeClass ( 'selected' );
        $(this).parent().addClass ( 'selected' );

        $('.ab-section').hide();

        this.openTab = $(this).attr('data-tab-class');
        $('.'+this.openTab).show();
      });

      // - ADD SECTION BUTTON
      $('#add-section-btn').off ( 'click' );
      $('#add-section-btn').on  ( 'click', function ( evt ) {
        Assessment.builder.section.add();
      });

      // - INITIALISE QUESTION BUTTONS
      Assessment.builder.refreshEvents();
    },

    reloadQuestions : function() {
      var qTable_src = $('script#question-table-tpl').html(),
          qTable_tpl = Handlebars.compile ( qTable_src ),
          qTable_htm;

      var postData = { assessmentID : Assessment.builder.editingAssessmentID };

      $.ajax({
        url: '/admin/AJAX-assessment-builder/getQuestionTable',
        data: postData,
        type: 'post',
        dataType: 'json',
        success: function ( returnedData ) {
          if ( returnedData.success ) {
            qTable_htm = qTable_tpl ( returnedData );
            $('.assessment-builder').html ( qTable_htm );
            Assessment.builder.refreshEvents();
          }
        }
      });
    },

    refreshEvents : function() {
      Assessment.builder.section.refreshEvents();
      Assessment.builder.question.refreshEvents();
    },

    section : {
      add : function() {
        var section_src = $('script#assessment-builder-section-tpl').html(),
            section_tpl = Handlebars.compile ( section_src ),
            section_htm;

        var initObj = {
          newSectionNo   : $('[id^=new-section-]').length,
          newSectionName : '[Enter Section Name]',
        };

        section_htm = section_tpl ( initObj );

        $('table.assessment-builder').append ( section_htm );

        Assessment.builder.section.refreshEvents();

        $('#new-section-'+initObj.newSectionNo).find('.edit-section-name').click();
      },

      save : function ( trSelector, mode ) {
        var methodName = ( mode === 'add' ) ? 'addSection' : 'editSection';
        var sendData = {
          newSectionName : $(trSelector).find('.section-name').html(),
          assessmentID   : Assessment.builder.editingAssessmentID,
          randomise      : $(trSelector).find('.cb-randomise').prop ( 'checked' ) ? 1 : 0,
          numToSelect    : $(trSelector).find('.num-no-to-select').val(),
        };

        if ( mode === 'edit' ) {
          sendData.sectionID = $(trSelector).attr('data-section-id');
        }

        $.ajax({
          url: '/admin/AJAX-assessment-builder/' + methodName,
          data: sendData,
          type: 'post',
          dataType: 'json',
          success: function ( returnedData ) {
            if ( returnedData.success ) {
              if ( mode === 'add' ) {
                $(trSelector).attr ( 'data-section-id', returnedData.section.id );
                $(trSelector).attr ( 'id', null );

                Assessment.builder.section.refreshEvents();
              }
            }
          }
        });

      },

      refreshEvents : function() {
        $('.edit-section-name').off ( 'click' );
        $('.edit-section-name').on  ( 'click', function ( evt ) {
          var td = $(this).parentsUntil('td').parent();
          var currName = td.find('.section-name').html();
          var editingHTML = 'Section: <input class="section-editing-name" value="' + currName + '">' +
                            '<button class="save-section-name-btn">Save</button>';

          td.find('.section-name').remove();
          td.find('.section-identifier').html ( editingHTML );
          td.find('.section-editing-name').select();

          $('.save-section-name-btn').off ( 'click' );
          $('.save-section-name-btn').on  ( 'click', function ( evt ) {
            var newName = td.find('.section-editing-name').val();
            var savedHTML = 'Section: <span class="section-name">' + newName + '</span>';
            var trSelector;

            td.find('.section-identifier').html ( savedHTML );

            if ( td.parent().attr('id') === undefined ) {
              // EDIT SECTION
              trSelector = 'tr[data-section-id=' + td.parent().attr('data-section-id') + ']';
              Assessment.builder.section.save ( trSelector, 'edit' );
            }
            else {
              // ADD SECTION
              trSelector = '#' + td.parent().attr('id');
              Assessment.builder.section.save ( trSelector, 'add' );
            }
          });
        });

        // - ADD QUESTION BUTTON
        $('.add-question-to-section').off ( 'click' );
        $('.add-question-to-section').on  ( 'click', function ( evt ) {
          Assessment.builder.editingSectionID = $(this).parentsUntil('tr').parent().attr('data-section-id');
          Assessment.builder.showSelectQuestionTypeToAdd ( Assessment.builder.editingSectionID );
        });

        // - DELETE SECTION
        $('.delete-section').off ( 'click' );
        $('.delete-section').on  ( 'click', function ( evt ) {
          var tr     = $(this).parentsUntil ( 'tr' ).parent(),
              data   = {
                sectionID  : tr.attr ( 'data-section-id' ),
              };

          popup.generatePopup({
            title: 'Delete Section?',
            method: 'ajax',
            ajaxUrl: '/admin/AJAX-assessment-builder/showDeleteSectionConfirm/',
            maxWidth: 400,
            maxHeight: 210,
            success: function() {
              $('#delete-section-from-assessment-btn').off ( 'click' );
              $('#delete-section-from-assessment-btn').on  ( 'click', function ( evt ) {
                $.ajax({
                  url: '/admin/AJAX-assessment-builder/deleteSectionFromAssessment',
                  data: data,
                  type: 'post',
                  dataType: 'json',
                  success: function ( returnedData ) {
                    // console.log(returnedData);
                    if ( returnedData.success ) {
                      main.flashData.show ( 'Section Successfully Deleted', 'negative' );
                      popup.close();
                      Assessment.builder.reloadQuestions();
                    }
                  }
                });
              });
            },
          });
        });

        // - RANDOMISE
        $('.cb-randomise').off ( 'change' );
        $('.cb-randomise').on  ( 'change', function ( evt ) {
          var sectionID  = $(this).parentsUntil('tr').parent().attr('data-section-id');
          var trSelector = 'tr[data-section-id="' + sectionID + '"]';

          Assessment.builder.section.save ( trSelector, 'edit' );
        });

        // - NUM TO SELECT
        $('.num-no-to-select').off ( 'change' );
        $('.num-no-to-select').on  ( 'change', function ( evt ) {
          var sectionID  = $(this).parentsUntil('tr').parent().attr('data-section-id');
          var trSelector = 'tr[data-section-id="' + sectionID + '"]';
          Assessment.builder.section.save ( trSelector, 'edit' );
        });

        $('.num-no-to-select').off ( 'keyup' );
        $('.num-no-to-select').on  ( 'keyup', function ( evt ) {
          var sectionID  = $(this).parentsUntil('tr').parent().attr('data-section-id');
          var trSelector = 'tr[data-section-id="' + sectionID + '"]';
          Assessment.builder.section.save ( trSelector, 'edit' );
        });
      },
    },

    question : {
      refreshEvents : function() {
        // - EDIT QUESTION EVENT
        $('.edit-question').off ( 'click' );
        $('.edit-question').on  ( 'click', function ( evt ) {
          var editingQuestionID = $(this).parentsUntil('.question').parent().attr('data-question-id');
          var assessmentSectionID = $(this).parentsUntil('.question').parent().attr('data-section-id');

          Assessment.builder.editingQuestionID = editingQuestionID;
          Assessment.builder.editingSectionID  = assessmentSectionID;

          Assessment.builder.showEditQuestionChoice ( editingQuestionID, assessmentSectionID );
        });

        // - DELETE QUESTION EVENT
        $('.remove-question').off ( 'click' );
        $('.remove-question').on  ( 'click', function ( evt ) {
          var tr         = $(this).parentsUntil ( 'tr' ).parent(),
              data   = {
                sectionID  : tr.attr ( 'data-section-id' ),
                questionID : tr.attr ( 'data-question-id' ),
              };

              popup.generatePopup({
                title: 'Delete Question?',
                method: 'ajax',
                ajaxUrl: '/admin/AJAX-assessment-builder/showDeleteQuestionChoice/' + data.sectionID + '/' + data.questionID,
                maxWidth: 400,
                maxHeight: 340,
                success: function() {
                  $('#delete-question-from-assessment-btn').off ( 'click' );
                  $('#delete-question-from-assessment-btn').on  ( 'click', function ( evt ) {
                    $.ajax({
                      url: '/admin/AJAX-assessment-builder/deleteQuestionFromAssessment',
                      data: data,
                      type: 'post',
                      dataType: 'json',
                      success: function ( returnedData ) {
                        if ( returnedData.success ) {
                          main.flashData.show ( 'Question Successfully Deleted', 'negative' );
                          popup.close();
                          Assessment.builder.reloadQuestions();
                        }
                      }
                    });
                  });

                  $('#delete-question-from-pool-btn').off ( 'click' );
                  $('#delete-question-from-pool-btn').on  ( 'click', function ( evt ) {
                    $.ajax({
                      url: '/admin/AJAX-assessment-builder/deleteQuestionFromPool',
                      data: data,
                      type: 'post',
                      dataType: 'json',
                      success: function ( returnedData ) {
                        if ( returnedData.success ) {
                          main.flashData.show ( 'Question Successfully Deleted', 'negative' );
                          popup.close();
                          Assessment.builder.reloadQuestions();
                        }
                      }
                    });
                  });
                },
              });
        });
      },
    },

    showSelectQuestionTypeToAdd : function ( assessmentSectionID ) {
      popup.generatePopup({
        title: 'Select Question Type',
        method: 'ajax',
        ajaxUrl: '/admin/AJAX-assessment-builder/showSelectQuestionTypeToAdd/' + assessmentSectionID,
        maxWidth: 300,
        maxHeight: 140,
        success: function() {
          $('#select-question-type').off ( 'change' );
          $('#select-question-type').on  ( 'change', function ( evt ) {
            if ( $(this).val() === '-' ) {
              $('#create-question-btn').hide();
            }
            else {
              $('#create-question-btn').show();
            }
          });

          $('#create-question-btn').off ( 'click' );
          $('#create-question-btn').on  ( 'click', function ( evt ) {
            Assessment.builder.showAddQuestion ( assessmentSectionID, $('#select-question-type').val() );
          });

          $('#create-question-btn').hide();
        },
      });
    },

    showAddQuestion : function ( assessmentSectionID, questionType ) {
      switch ( questionType ) {
        case 'multiple_choice':
          Assessment.builder.multipleChoice.showAdd();
          break;
        case 'drag_in_the_blank':
          Assessment.builder.dragInTheBlank.showAdd();
          break;
        case 'fill_in_the_blank':
          Assessment.builder.fillInTheBlank.showAdd();
          break;
        case 'drag_and_drop':
          Assessment.builder.dragAndDrop.showAdd();
          break;
      }
    },

    showEditQuestion : function() {
      switch ( Assessment.builder.editingQuestion.type ) {
        case 'multiple_choice':
          Assessment.builder.multipleChoice.showEdit();
          break;
        case 'drag_in_the_blank':
          Assessment.builder.dragInTheBlank.showEdit();
          break;
        case 'fill_in_the_blank':
          Assessment.builder.fillInTheBlank.showEdit();
          break;
        case 'drag_and_drop':
          Assessment.builder.dragAndDrop.showEdit();
          break;
      }
    },

    /**
     * THIS FUNCTION SERVES THE USER WITH A CHOICE, AS THE QUESTIONS ARE ALL
     * PART OF A GENERAL POOL, EDITING A QUESTION THAT'S USED IN OTHER
     * ASSESSMENTS WILL MEAN IT'S CHANGED IN ALL ASSESSMENTS
     * CHOICE IS DO YOU WANT TO EDIT THIS QUESTION OR MAKE A COPY OF IT?
     */
    showEditQuestionChoice : function ( questionID, assessmentSectionID ) {
      popup.generatePopup ({
        title: 'Make a copy?',
        method: 'ajax',
        ajaxUrl: '/admin/AJAX-assessment-builder/showEditQuestionChoice/' + questionID,
        maxHeight: 220,
        success: function() {
          $('#edit-question-copy-btn').off ( 'click' );
          $('#edit-question-copy-btn').on  ( 'click', function ( evt ) {
            Assessment.builder.copyQuestionAndEdit ( questionID, assessmentSectionID );
          });

          $('#edit-this-question-btn').off ( 'click' );
          $('#edit-this-question-btn').on  ( 'click', function ( evt ) {
            Assessment.builder.getQuestionData ( questionID, true );
          });
        },
      });
    },

    copyQuestionAndEdit : function ( questionID, assessmentSectionID ) {
      $.ajax({
        url: '/admin/AJAX-assessment-builder/copyQuestion/',
        type: 'post',
        data: {questionID:questionID, assessmentSectionID:assessmentSectionID},
        dataType: 'json',
        success: function ( returnedData ) {
          if ( returnedData.success ) {
            Assessment.builder.getQuestionData ( questionID, true );
          }
        },
      });
    },

    getQuestionData : function ( questionID, andEdit ) {
      $.ajax({
        url: '/admin/AJAX-assessment-builder/getQuestionData/',
        type: 'post',
        data: {questionID:questionID},
        dataType: 'json',
        success: function ( returnedData ) {
          if ( returnedData.success ) {
            Assessment.builder.editingQuestion = returnedData.question;

            if ( andEdit ) {
              Assessment.builder.showEditQuestion();
            }
          }
        },
      });
    },

    saveQuestion : function ( questionID, text, instructions, custom ) {
      var sendData = {
        'questionID'   : questionID,
        'text'         : text,
        'instructions' : instructions,
        'custom'       : JSON.stringify ( custom ),
      };

      $.ajax({
        url: '/admin/AJAX-assessment-builder/saveQuestion',
        data: sendData,
        type: 'post',
        dataType: 'json',
        success: function ( returnedData ) {
          if ( returnedData.success ) {
            main.flashData.show (
              'Question Saved',
              'positive'
            );
          }
          // console.log ( returnedData );
        }
      });
    },

    insertQuestion : function ( sectionID, type, text, instructions, custom ) {
      //console.log(sectionID, text, instructions, custom);
      var sendData = {
        'sectionID'    : sectionID,
        'type'         : type,
        'text'         : text,
        'instructions' : instructions,
        'custom'       : JSON.stringify ( custom ),
      };

      $.ajax({
        url: '/admin/AJAX-assessment-builder/insertQuestion',
        data: sendData,
        type: 'post',
        dataType: 'json',
        success: function ( returnedData ) {
          if ( returnedData.success ) {
            main.flashData.show (
              'Question Created',
              'positive'
            );

            Assessment.builder.reloadQuestions();
          }
        }
      });
    },

    // - QUESTION TYPES

    /////////////////////////
    // - MULTIPLE CHOICE - //
    /////////////////////////

    multipleChoice : {

      showAdd : function() {
        Assessment.builder.editingQuestion = {
          text : '',
          answers : [],
        };

        var question_src = $('script#multiple-choice-add-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        CKEDITOR.replace (
          'text',
          Assessment.builder.ckeditor.configs.multiple_choice_text
        );

        QuickHelp.init();

        Table.addAnotherRowInit ( '.multiple-choice-answers', '.add-another-answer', '.multiple-choice-answer:last-child', {
          blank : [
            'input[name="id"]',
            'input[name="text"]',
            'input[name="correct"]',
            'input[name="score"]',
          ],
          onAdd : function () {
            Assessment.builder.multipleChoice.refreshEvents();
          },
        });

        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.multipleChoice.insert();
        });

        Assessment.builder.multipleChoice.refreshEvents();
      },

      showEdit : function() {
        Assessment.builder.editingQuestion.text = str.decode ( Assessment.builder.editingQuestion.text );
        var answers = Assessment.builder.editingQuestion.custom.answers;

        for ( var i = 0; i < answers.length; i++ ) {
          answers[i].text = str.decode ( answers[i].text );
        }

        var custom = Assessment.builder.editingQuestion.custom;

        var question_src = $('script#multiple-choice-edit-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        CKEDITOR.replace (
          'text',
          Assessment.builder.ckeditor.configs.multiple_choice_text
        );

        QuickHelp.init();

        Table.addAnotherRowInit ( '.multiple-choice-answers', '.add-another-answer', '.multiple-choice-answer:last-child', {
          blank : [
            'input[name="id"]',
            'input[name="text"]',
            'input[name="correct"]',
            'input[name="score"]',
          ],
          onAdd : function () {
            Assessment.builder.multipleChoice.refreshEvents();
          },
        });

        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.multipleChoice.save();
        });

        Assessment.builder.multipleChoice.refreshEvents();
      },

      save : function() {
        if ( $('.multiple-choice-answer input:checked[name="correct"]').length > 0 ) {
          var tempAnswerObj,
              saveObj = {
                answers : [],
              };

          $('.multiple-choice-answer').each ( function ( answerIndex, answerElem ) {
            tempAnswerObj = {
              id      : $(answerElem).find('input[name="id"]').val(),
              text    : $(answerElem).find('input[name="text"]').val(),
              correct : $(answerElem).find('input[name="correct"]').prop ( 'checked' ),
              score   : $(answerElem).find('input[name="score"]').val(),
            };

            saveObj.answers.push ( tempAnswerObj );
          });

          Assessment.builder.saveQuestion (
            Assessment.builder.editingQuestionID,
            CKEDITOR.instances.text.getData(),
            '',
            saveObj
          );
        }
        else {
          main.flashData.show ( 'At least one answer must be marked as correct.' , 'negative' );
        }
      },

      insert : function() {
        var tempAnswerObj,
            saveObj = {
              answers : [],
            };

        $('.multiple-choice-answer').each ( function ( answerIndex, answerElem ) {
          tempAnswerObj = {
            id      : $(answerElem).find('input[name="id"]').val(),
            text    : $(answerElem).find('input[name="text"]').val(),
            correct : $(answerElem).find('input[name ="correct"]').prop ( 'checked' ),
            score   : $(answerElem).find('input[name="score"]').val(),
          };

          saveObj.answers.push ( tempAnswerObj );
        });

        Assessment.builder.insertQuestion (
          Assessment.builder.editingSectionID,
          'multiple_choice',
          CKEDITOR.instances.text.getData(),
          '',
          saveObj
        );
      },

      refreshEvents : function() {
        // - DELETE ANSWER
        $('.multiple-choice-answers .delete-answer').off ( 'click' );
        $('.multiple-choice-answers .delete-answer').on  ( 'click', function ( evt ) {
          if ( $('.multiple-choice-answers .delete-answer').length > 1 ) {
            $(this).parentsUntil ( '.multiple-choice-answer' ).parent().remove();
          }
        });
      },

    },

    ///////////////////////////
    // - DRAG IN THE BLANK - //
    ///////////////////////////

    dragInTheBlank : {

      showAdd : function() {
        Assessment.builder.editingQuestion = {};

        // - GET THE QUESTION TEMPLATE FROM question-type-templates.html AND FILL IT
        var question_src = $('script#drag-in-the-blank-add-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        // - WIDTH AND HEIGHT FOR POPUP
        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        // - SETUP CKEDITOR FOR THE QUESTION TEXT
        CKEDITOR.replace (
          'instructions',
          Assessment.builder.ckeditor.configs.instructions
        );

        CKEDITOR.replace (
          'text',
          Assessment.builder.ckeditor.configs.drag_in_the_blank_text
        );

        // - ONLY REGISTER STYLE IF NOT ALREADY REGISTERED
        if ( CKEDITOR.stylesSet.registered.ditb === undefined ) {
          // - THESE STYLES ARE TO HIGHLIGHT THE ANSWERS AND ARE AVAILABLE IN THE STYLE MENU IN CKEDITOR
          CKEDITOR.stylesSet.add( 'ditb', [
              // Inline Styles
              {
                name: 'Answer Placeholder',
                element: 'span',
                attributes: {
                  class: 'ditb-answer',
                }
              },
          ] );
        }

        CKEDITOR.config.stylesCombo_stylesSet = 'ditb';

        // - INITIALISE THE QUICK HELP LINKS
        QuickHelp.init();

        // - ADD SAVE BUTTON TO THE TOOLBAR IN THE POPUP
        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.dragInTheBlank.insert();
        });
      },

      showEdit : function() {
        // - DECODE THE QUESTION TEXT
        Assessment.builder.editingQuestion.text = str.decode ( Assessment.builder.editingQuestion.text );

        // - GET THE CUSTOM DATA FOR THE QUESTION
        var custom = Assessment.builder.editingQuestion.custom;

        // - GET THE QUESTION TEMPLATE FROM question-type-templates.html AND FILL IT
        var question_src = $('script#drag-in-the-blank-edit-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        // - WIDTH AND HEIGHT FOR POPUP
        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        // - SETUP CKEDITOR FOR THE QUESTION TEXT
        CKEDITOR.replace (
          'instructions',
          Assessment.builder.ckeditor.configs.instructions
        );

        CKEDITOR.replace (
          'text',
          Assessment.builder.ckeditor.configs.drag_in_the_blank_text
        );

        // - ONLY REGISTER STYLE IF NOT ALREADY REGISTERED
        if ( CKEDITOR.stylesSet.registered.ditb === undefined ) {
          // - THESE STYLES ARE TO HIGHLIGHT THE ANSWERS AND ARE AVAILABLE IN THE STYLE MENU IN CKEDITOR
          CKEDITOR.stylesSet.add( 'ditb', [
              // Inline Styles
              {
                name: 'Answer Placeholder',
                element: 'span',
                attributes: {
                  class: 'ditb-answer',
                }
              },
          ] );
        }

        CKEDITOR.config.stylesCombo_stylesSet = 'ditb';

        // - INITIALISE THE QUICK HELP LINKS
        QuickHelp.init();

        // - ADD SAVE BUTTON TO THE TOOLBAR IN THE POPUP
        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.dragInTheBlank.save();
        });
      },

      save : function() {
        var saveObj = '';

        Assessment.builder.saveQuestion (
          Assessment.builder.editingQuestionID,
          CKEDITOR.instances.text.getData(),
          CKEDITOR.instances.instructions.getData(),
          saveObj
        );
      },

      insert : function() {
        var saveObj = '';

        Assessment.builder.insertQuestion (
          Assessment.builder.editingSectionID,
          'drag_in_the_blank',
          CKEDITOR.instances.text.getData(),
          CKEDITOR.instances.instructions.getData(),
          saveObj
        );
      },
    },

    ///////////////////////////
    // - FILL IN THE BLANK - //
    ///////////////////////////

    fillInTheBlank : {

      showAdd : function() {
        Assessment.builder.editingQuestion = {};

        // - GET THE QUESTION TEMPLATE FROM question-type-templates.html AND FILL IT
        var question_src = $('script#fill-in-the-blank-add-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        // - WIDTH AND HEIGHT FOR POPUP
        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        // - SETUP CKEDITOR FOR THE QUESTION TEXT
        CKEDITOR.replace (
          'instructions',
          Assessment.builder.ckeditor.configs.instructions
        );

        CKEDITOR.replace (
          'text',
          Assessment.builder.ckeditor.configs.fill_in_the_blank_text
        );

        // - ONLY REGISTER STYLE IF NOT ALREADY REGISTERED
        if ( CKEDITOR.stylesSet.registered.fitb === undefined ) {
          // - THESE STYLES ARE TO HIGHLIGHT THE ANSWERS AND ARE AVAILABLE IN THE STYLE MENU IN CKEDITOR
          CKEDITOR.stylesSet.add( 'fitb', [
              // Inline Styles
              {
                name: 'Answer Placeholder',
                element: 'span',
                attributes: {
                  class: 'fitb-answer',
                }
              },
          ] );
        }

        CKEDITOR.config.stylesCombo_stylesSet = 'fitb';

        // - INITIALISE THE QUICK HELP LINKS
        QuickHelp.init();

        // - ADD SAVE BUTTON TO THE TOOLBAR IN THE POPUP
        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.fillInTheBlank.insert();
        });
      },

      showEdit : function() {
        // - DECODE THE QUESTION TEXT
        Assessment.builder.editingQuestion.text = str.decode ( Assessment.builder.editingQuestion.text );

        // - GET THE CUSTOM DATA FOR THE QUESTION
        var custom = Assessment.builder.editingQuestion.custom;

        // - GET THE QUESTION TEMPLATE FROM question-type-templates.html AND FILL IT
        var question_src = $('script#fill-in-the-blank-edit-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        // - WIDTH AND HEIGHT FOR POPUP
        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        // - SETUP CKEDITOR FOR THE QUESTION TEXT
        CKEDITOR.replace (
          'instructions',
          Assessment.builder.ckeditor.configs.instructions
        );

        CKEDITOR.replace (
          'text',
          Assessment.builder.ckeditor.configs.fill_in_the_blank_text
        );

        // - ONLY REGISTER STYLE IF NOT ALREADY REGISTERED
        if ( CKEDITOR.stylesSet.registered.fitb === undefined ) {
          // - THESE STYLES ARE TO HIGHLIGHT THE ANSWERS AND ARE AVAILABLE IN THE STYLE MENU IN CKEDITOR
          CKEDITOR.stylesSet.add( 'fitb', [
              // Inline Styles
              {
                name: 'Answer Placeholder',
                element: 'span',
                attributes: {
                  class: 'fitb-answer',
                }
              },
          ] );
        }

        CKEDITOR.config.stylesCombo_stylesSet = 'fitb';

        // - INITIALISE THE QUICK HELP LINKS
        QuickHelp.init();

        // - ADD SAVE BUTTON TO THE TOOLBAR IN THE POPUP
        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.fillInTheBlank.save();
        });
      },

      save : function() {
        var saveObj = '';

        Assessment.builder.saveQuestion (
          Assessment.builder.editingQuestionID,
          CKEDITOR.instances.text.getData(),
          CKEDITOR.instances.instructions.getData(),
          saveObj
        );
      },

      insert : function() {
        var saveObj = '';

        Assessment.builder.insertQuestion (
          Assessment.builder.editingSectionID,
          'fill_in_the_blank',
          CKEDITOR.instances.text.getData(),
          CKEDITOR.instances.instructions.getData(),
          saveObj
        );
      },

    },

    ///////////////////////
    // - DRAG AND DROP - //
    ///////////////////////

    dragAndDrop : {

      showAdd : function() {

        Assessment.builder.editingQuestion = {};

        // - GET THE QUESTION TEMPLATE FROM question-type-templates.html AND FILL IT
        var question_src = $('script#drag-and-drop-add-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        // - WIDTH AND HEIGHT FOR POPUP
        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        Table.addAnotherRowInit ( '.dad-categories', '.add-another-category', '.dad-category:last-child', {
          blank : [
            'input[name="category"]',
            'input[name*="item"]',
          ],
          onAdd : function() {

            var numCategories = $('.dad-categories .dad-category').length;
            var newCategoryID = numCategories - 1;

            $('.new-item').attr ( 'id', newCategoryID );

            /**
             * REMOVE ALL BUT FIRST ITEM IN THIS NEW CATEGORY
             * FOR INFO ON .new-item  LOOK IN THE FUNCTIONS COMMENTS
             */

            $('.new-item').find('.dad-item:not(:first-child)').remove();

            // - CHANGE CATEGORY #
            $('.new-item h4').html ( 'Category ' + numCategories );

            Assessment.builder.dragAndDrop.refreshEvents();

            /**
             * AUTOSCROLL THE POPUP DOWN TO THE BOTTOM WHICH IS
             * WHERE THE NEW CATEGORY WILL BE
             */

            TweenMax.to ( $('.popup-content'), 0.5, {
              "scrollTop" : $('.popup-content').height(),
            });
          },
        });

        // - SETUP CKEDITOR FOR THE QUESTION TEXT
        CKEDITOR.replace (
          'instructions',
          Assessment.builder.ckeditor.configs.instructions
        );

        // - INITIALISE THE QUICK HELP LINKS
        QuickHelp.init();

        // - ADD SAVE BUTTON TO THE TOOLBAR IN THE POPUP
        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.dragAndDrop.insert();
        });

        Assessment.builder.dragAndDrop.refreshEvents();
      },

      showEdit : function() {
        // - DECODE THE QUESTION TEXT
        Assessment.builder.editingQuestion.text = str.decode ( Assessment.builder.editingQuestion.text );

        // - GET THE CUSTOM DATA FOR THE QUESTION
        var custom = Assessment.builder.editingQuestion.custom;

        // - GET THE QUESTION TEMPLATE FROM question-type-templates.html AND FILL IT
        var question_src = $('script#drag-and-drop-edit-tpl').html(),
            question_tpl = Handlebars.compile ( question_src ),
            question_htm;

        question_htm = question_tpl ( Assessment.builder.editingQuestion );

        // - WIDTH AND HEIGHT FOR POPUP
        popup.setWidth  ( '80%' );
        popup.setHeight ( '80%' );

        // - SET HTML CONTENT FOR BOTH MENUES
        $('.popup-content').html ( question_htm );

        Table.addAnotherRowInit ( '.dad-categories', '.add-another-category', '.dad-category:last-child', {
          blank : [
            'input[name="category"]',
            'input[name*="item"]',
          ],
          onAdd : function() {

            var numCategories = $('.dad-categories .dad-category').length;
            var newCategoryID = numCategories - 1;

            $('.new-item').attr ( 'id', newCategoryID );

            /**
             * REMOVE ALL BUT FIRST ITEM IN THIS NEW CATEGORY
             * FOR INFO ON .new-item  LOOK IN THE FUNCTIONS COMMENTS
             */

            $('.new-item').find('.dad-item:not(:first-child)').remove();

            // - CHANGE CATEGORY #
            $('.new-item h4').html ( 'Category ' + numCategories );

            Assessment.builder.dragAndDrop.refreshEvents();

            /**
             * AUTOSCROLL THE POPUP DOWN TO THE BOTTOM WHICH IS
             * WHERE THE NEW CATEGORY WILL BE
             */

            TweenMax.to ( $('.popup-content'), 0.5, {
              "scrollTop" : $('.popup-content').height(),
            });
          },
        });

        // - SETUP CKEDITOR FOR THE QUESTION TEXT
        CKEDITOR.replace (
          'instructions',
          Assessment.builder.ckeditor.configs.instructions
        );

        // - INITIALISE THE QUICK HELP LINKS
        QuickHelp.init();

        // - ADD SAVE BUTTON TO THE TOOLBAR IN THE POPUP
        popup.toolbar (
          '<button type="button" name="btn-edit-question" class="popup-toolbar-btn">' +
            '<i class="fa fa-save"></i> Save' +
          '</button>'
        );

        // - SET SAVE FUNCTION
        $('button[name="btn-edit-question"]').off ( 'click' );
        $('button[name="btn-edit-question"]').on  ( 'click', function ( evt ) {
          Assessment.builder.dragAndDrop.save();
        });

        Assessment.builder.dragAndDrop.refreshEvents();
      },

      save : function() {
        var tempCategoryObj,
            saveObj = {
              categories : [],
            };

        $('.dad-category').each ( function ( categoryIndex, categoryElem ) {
          tempCategoryObj = {
            name : str.encode ( $(categoryElem).find('input[name="category"]').val() ),
            items : []
          };

          $(categoryElem).find('.dad-item').each ( function ( itemIndex, itemElem ) {
            tempCategoryObj.items.push (
              str.encode ( $(itemElem).find('input[name="item"]').val() )
            );
          });

          saveObj.categories.push ( tempCategoryObj );
        });

        Assessment.builder.saveQuestion (
          Assessment.builder.editingQuestionID,
          '',
          CKEDITOR.instances.instructions.getData(),
          saveObj
        );
      },

      insert : function() {
        var tempCategoryObj,
            saveObj = {
              categories : [],
            };

        $('.dad-category').each ( function ( categoryIndex, categoryElem ) {
          tempCategoryObj = {
            name : str.encode ( $(categoryElem).find('input[name="category"]').val() ),
            items : []
          };

          $(categoryElem).find('.dad-item').each ( function ( itemIndex, itemElem ) {
            tempCategoryObj.items.push (
              str.encode ( $(itemElem).find('input[name="item"]').val() )
            );
          });

          saveObj.categories.push ( tempCategoryObj );
        });

        //args - sectionID, type, text, instructions, custom
        Assessment.builder.insertQuestion (
          Assessment.builder.editingSectionID,
          'drag_and_drop',
          '',
          CKEDITOR.instances.instructions.getData(),
          saveObj
        );
      },

      refreshEvents : function() {
        // - DELETE CATEGORY
        $('.dad-delete-category-icon').off ( 'click' );
        $('.dad-delete-category-icon').on  ( 'click', function ( evt ) {
          if ( $('.dad-category').length > 2 ) {
            $(this).parent().remove();

            // - NOW CHANGE THE CATEGORY #'s
            Assessment.builder.dragAndDrop.refreshCategoryNos();
          }
        });

        // - DELETE ITEM
        $('.dad-delete-item-icon').on  ( 'click', function ( evt ) {
          if ( $(this).parentsUntil('.dad-categories').find('.dad-item').length > 1 ) {
            $(this).parent().remove();
          }
        });

        // - ADD ITEM IN EACH CATEGORY
        $('.dad-category').each ( function ( index, elem ) {
          Table.addAnotherRowInit ( '#' + $(elem).attr('id'), '#' + $(elem).attr('id') + ' .add-another-item', '.dad-item:last-child', {
            blank : ['input[name*="item"]'],
            onAdd : function() {
              Assessment.builder.dragAndDrop.refreshEvents();
            },
          });
        });
      },

      refreshCategoryNos : function() {
        $('.dad-category').each ( function ( index, elem ) {
          $(elem).find('.category-no').html ( 'Category ' + ( index + 1 ) );
        });
      },

    },

  },

  ////////////////
  // - PLAYER - //
  ////////////////

  player : {
    assessmentID : null,
    onPass : null,
    questionStage : null,

    // - DEFAULT SETTINGS FOR EXTRA INFO POPUP
    extra_info : {
      default_width : '900px',
      default_height : 'auto',
      padding : 30,
    },
    passed : false,// - PASSED STATUS OF THE ASSESSMENT
    percentageScore : 0,// - PERCENTAGE SCORE CALCULATED, THIS IS CALCULATED FROM CORRECT MARKS ACHIEVED / TOTAL MARKS AVAILABLE
    score : 0,// - CURRENT INTEGER SCORE (NUMBER OF CORRECT MARKS)
    totalScore : 0,// - TOTAL MARKS AVAILABLE

    feedbackAfterQuestions : {
      0 : 'noFeedback',
      1 : 'showAnswerStatus',
      2 : 'showAnswer',
      3 : 'showCustomFeedback',
    },

    feedbackModeAtSummary : {
      0 : 'showScoreOnly',
      1 : 'showScoreAndListAnswerStatuses',
      2 : 'showScoreAndListAnswers',
      3 : 'showScoreAndListAnswersWithFeedback',
      4 : 'notScored',
    },

    alreadyComplete : function() {
      // - IF PART OF A COURSE, CHECK ITS JSONTRAININGDATA
      if ( Courses.currentCourse.uciID !== null && Courses.currentCourse.uciID !== undefined ) {
        var sectionIdx = Courses.currentCourse.currentSectionIdx;
        var slideIdx = Courses.currentCourse.currentSlideIdx;

        return Courses.currentCourse.JSONTrainingData.sections[sectionIdx].slides[slideIdx].s === 2;
      }
      else {
        // TODO
      }
    },

    showAlreadyComplete : function ( message ) {
      if ( message === undefined ) {
        message = "<p>You have already completed this assessment. Please click 'Next' or press the right arrow <i class=\"fa fa-arrow-circle-right\"></i> key to continue.</p>";
      }

      $('#already-complete-message').html ( message );
      $('#already-complete').removeClass ( 'dn' );
    },

    calculatePercentage : function() {
      // - CALCULATES THE PERCENTAGE SCORE
      Assessment.player.percentageScore = Math.round (
        Assessment.player.score / Assessment.player.totalScore * 100
      );
    },

    closeExtraInfo : function() {
      TweenMax.to ( '#extra-info', 0.3, {
        top: '140%',
        onComplete: function() {
          // - HIDES EXTRA INFO POPUP
          $('#extra-info').hide();
          // - HIDES BLACKOUT SHROUD DIV
          $('#extra-info-blackout').hide();
        },
      });
    },

    getTotalScore : function() {
      var section, question, sAndQIndexes, total = 0;

      // - LOOP THROUGH THE QUESTIONS THAT HAVE BEEN SELECTED
      for ( var i = 0; i < Assessment.player.questionSet.length; i++ ) {
        // - GET THE QUESTION DATA : AS INDEX SETS (0, 1) IS QUESTION 1 OF SECTION 0
        sAndQIndexes = Assessment.player.questionSet[i];

        // - SET THE CURRENT QUESTION TO THE SELECTED XML TAG
        //console.log(sAndQIndexes, sAndQIndexes.section, Assessment.data.sections);
        section = Assessment.data.sections[sAndQIndexes.section];
        question = section.questions[sAndQIndexes.question];
        // - ADD THE QUESTIONS TOTAL MARKS TO THE RUNNING TOTAL
        total += question.possible_marks;
      }

      return total;
    },

    indexSectionsAndQuestions : function() {
      // - FUNCTION GIVES EACH SECTION AND ALL CHILD QUESTIONS A ZERO-BASED INDEX
      var sections = Assessment.data.sections;

      // - LOOP THROUGH EACH SECTION
      for(var s = 0; s < sections.length; s++) {
        // - SET SECTION INDEX TO LOOP ITERATION
        sections[s].index = s;

        // - GET THE QUESTIONS OF THIS SECTION
        var questions = sections[s].questions;

        // - LOOP THROUGH EACH QUESTION
        for(var q = 0; q < questions.length; q++) {
          // - SET QUESTION INDEX TO LOOP ITERATION
          questions[q].index = q;
        }
      }

    },


    loadAssessment : function ( assessmentID, saveAssessmentAttemptFunc ) {
      // Athena.nav.hideButtons ( ['back', 'replay', 'next'] );
      // - FUNCTION RESPONSABLE FOR LOADING ASSESSMENT DATA AND INITIALISING ASSESSMENT
      Assessment.player.assessmentID = assessmentID;
      Assessment.player.score = 0;
      Assessment.player.saveAttempt = saveAssessmentAttemptFunc;

      var sendData = {
        assessmentID: assessmentID,
      };

      $.ajax({
        url: '/AJAX-assessment/loadAssessment',
        type: 'post',
        data: sendData,
        dataType: 'json',
        success: function ( returnedData ) {
          console.log(returnedData);
          Assessment.data = returnedData;
          // - PROCESS EACH SETTING
          Assessment.data.settings = {
            passPercentage : Number ( returnedData.pass_percentage ),
            pickNumFromPool : Number ( returnedData.pick_num_from_pool ),
            pickFromSections : ( returnedData.pick_from_sections == "1" ) ? true : false,
            shuffleQuestions : ( returnedData.shuffle_questions == "1" ) ? true : false,
            maintainOrderOfSections : ( returnedData.maintain_order_of_sections == "1" ) ? true : false,
            includeSectionLabelsInQuestionNumber : ( returnedData.include_section_labels_in_question_number == "1" ) ? true : false,
            feedbackAfterQuestions : Assessment.player.feedbackAfterQuestions[Number ( returnedData.feedback_after_questions )],
            feedbackModeAtSummary : Number ( returnedData.feedback_mode_at_summary ),
            showCloseBtnAfterComplete : returnedData.showCloseBtnAfterComplete,
          };

          // - ASSIGNS INDEX VALUES TO EACH SECTION AND QUESTION ELEMENT
          Assessment.player.indexSectionsAndQuestions();

          // - ASSIGNS DEFAULTS SCORES TO EACH QUESTION OF 1 IF NO XML ATTRIBUTE PRESENT
          Assessment.player.setDefaultScores();

          // - EMPTY Q SET
          Assessment.player.questionSet = [];

          // - ALGORITHM TO SELECT WHICH QUESTIONS TO USE, SETTINGS IN XML FOR THIS
          Assessment.player.pickQuestions();

          // - GET TOTAL SCORE
          Assessment.player.totalScore = Assessment.player.getTotalScore();

          // - LOAD FIRST QUESTION
          Assessment.player.currQuestionIndex = 0;
          Assessment.player.loadQuestion ( Assessment.player.currQuestionIndex );

          // - ACTIVATE NEXT BTN
          $('.next-question-btn, .finish-quiz-btn').off ( 'click' );
          $('.next-question-btn, .finish-quiz-btn').on  ( 'click', function ( evt ) {
            Assessment.player.nextQuestionBtnClicked();
          });
        }
      });

      // - HIDE THE SUMMARY
      $('#summary').hide();

      ////////////////
      // - EVENTS - //
      ////////////////

      // - CLICK EVENT FOR VIEW EXTRA INFO BUTTON
      $('.view-extra-info-btn').on('click', function(evt) {
        Assessment.player.viewExtraInfo();
      });

      // - CLICK EVENT FOR CLOSE EXTRA INFO BUTTON
      $('#extra-info-close-btn').on('click', function(evt) {
        Assessment.player.closeExtraInfo();
      });
    },

    loadAssessmentJSON : function ( assessmentJSON_URL, saveAssessmentAttemptFunc, onPass ) {
      // Courses.nav.hideButtons ( ['back', 'replay', 'next'] );// write this function
      // - FUNCTION RESPONSABLE FOR LOADING ASSESSMENT DATA AND INITIALISING ASSESSMENT
      Assessment.player.assessmentJSON_URL = assessmentJSON_URL;
      Assessment.player.score = 0;
      Assessment.player.saveAttempt = saveAssessmentAttemptFunc;

      $.ajax({
        url: assessmentJSON_URL,
        dataType: 'json',
        success: function ( returnedData ) {
          console.log(returnedData);
          Assessment.data = returnedData;
          // - PROCESS EACH SETTING
          Assessment.data.settings = {
            passPercentage : Number ( returnedData.pass_percentage ),
            pickNumFromPool : Number ( returnedData.pick_num_from_pool ),
            pickFromSections : ( returnedData.pick_from_sections == "1" ) ? true : false,
            shuffleQuestions : ( returnedData.shuffle_questions == "1" ) ? true : false,
            maintainOrderOfSections : ( returnedData.maintain_order_of_sections == "1" ) ? true : false,
            includeSectionLabelsInQuestionNumber : ( returnedData.include_section_labels_in_question_number == "1" ) ? true : false,
            feedbackAfterQuestions : Assessment.player.feedbackAfterQuestions[Number ( returnedData.feedback_after_questions )],
            feedbackModeAtSummary : Number ( returnedData.feedback_mode_at_summary ),
            showCloseBtnAfterComplete : returnedData.showCloseBtnAfterComplete,
            showCustomMessageAfterComplete : returnedData.showCustomMessageAfterComplete,
            showExplanationsAfterQuestions : returnedData.showExplanationsAfterQuestions,
          };

          if ( returnedData.showCustomMessageAfterComplete ) {
            Assessment.data.settings.customMessageAfterComplete = returnedData.customMessageAfterComplete;
          }

          // - IF THE ASSESSMENT IS ALREADY PASSED, SHOW RELEVANT END FEEDBACK
          if ( Assessment.player.alreadyComplete() ) {
            Assessment.player.showAlreadyComplete();
          }
          else {
            // - ASSIGNS INDEX VALUES TO EACH SECTION AND QUESTION ELEMENT
            Assessment.player.indexSectionsAndQuestions();

            // - ASSIGNS DEFAULTS SCORES TO EACH QUESTION OF 1 IF NO XML ATTRIBUTE PRESENT
            Assessment.player.setDefaultScores();

            // - EMPTY Q SET
            Assessment.player.questionSet = [];

            // - ALGORITHM TO SELECT WHICH QUESTIONS TO USE, SETTINGS IN XML FOR THIS
            Assessment.player.pickQuestions();

            // - GET TOTAL SCORE
            Assessment.player.totalScore = Assessment.player.getTotalScore();

            // - LOAD FIRST QUESTION
            Assessment.player.currQuestionIndex = 0;
            Assessment.player.loadQuestion ( Assessment.player.currQuestionIndex );

            // - ACTIVATE NEXT BTN
            $('.next-question-btn, .finish-quiz-btn').off ( 'click' );
            $('.next-question-btn, .finish-quiz-btn').on  ( 'click', function ( evt ) {
              Assessment.player.nextQuestionBtnClicked();
            });

            // - OVERRIDE THE MAIN NEXT BTN
            Courses.footerNav.removeNextClick();
            $('#next-btn').off ( 'click.assessment-next' );
            $('#next-btn').on  ( 'click.assessment-next', function ( evt ) {
              switch ( Assessment.player.questionStage ) {
                case 1:
                  $('.submit-btn').click();
                  break;
                case 2:
                  $('.show-explanation-btn').click();
                  break;
                case 3:
                  $('#dynamic-popup-close-btn').click();
                  break;
                case 4:
                  $('#multiple-choice .next-question-btn').click();
                  break;
              }
            });

            // - SET ON PASS
            Assessment.player.onPass = onPass;
          }
        }
      });

      // - HIDE THE SUMMARY
      $('#summary').hide();

      ////////////////
      // - EVENTS - //
      ////////////////

      // - CLICK EVENT FOR VIEW EXTRA INFO BUTTON
      $('.view-extra-info-btn').on('click', function(evt) {
        Assessment.player.viewExtraInfo();
      });

      // - CLICK EVENT FOR CLOSE EXTRA INFO BUTTON
      $('#extra-info-close-btn').on('click', function(evt) {
        Assessment.player.closeExtraInfo();
      });
    },

    loadCommonQTypeElements : function() {
      // console.log('loadCommonQTypeElements');
      // - CERTAIN ELEMENTS ARE AVAILABLE TO ALL QUESTIONS
      // - SUCH AS QUESTION NUMBER, QUESTION TEXT, EXTRA INFO BOX ETC.

      // - GET VALUES Q NUMBER AND Q TEXT DATA FROM XML
      var questionNumber,
          questionText = Assessment.player.currQuestion.text;

      // - THIS WAS IF WE WANT THE QUESTION TO BE BASED ON ITS POSITION IN THE BUILDER
      //if ( Assessment.player.currQuestion.soft_id === null ) {
      //  questionNumber = Assessment.player.currQuestion.index + 1;
      //}
      //else {
      //  questionNumber = Assessment.player.currQuestion.soft_id;
      //}

      questionNumber = Assessment.player.currQuestionIndex + 1;

      // - IF THE QUESTION HAS A NUMBER SET IT
      if ( Assessment.data.settings.includeSectionLabelsInQuestionNumber ) {
        questionNumber = Assessment.player.currSection.name + questionNumber;
      }

      $('#' + Assessment.player.currQuestionType + ' .question-no').html ( questionNumber );

      // - SET THE QUESTION TEXT
      $('#' + Assessment.player.currQuestionType + ' .question').html ( questionText );

      // - IF THERE IS ANY EXTRA INFO
      if ( Assessment.player.currQuestion.extra_info_content !== null ) {
        var extraInfoHTML = Assessment.player.currQuestion.extra_info_content;
        var extraInfoBtnText;

        // - SET THE CONTENT
        $('#extra-info-content').html ( extraInfoHTML );

        // - MAKE THE BUTTON VISIBLE
        $('#' + Assessment.player.currQuestionType + ' .view-extra-info-btn').show();

        // - IF BUTTON TEXT IS SET, SET IT, IF NOT DEFAULT TO VIEW EXTRA INFO
        if ( Assessment.player.currQuestion.extra_info_btn_text !== null ) {
          extraInfoBtnText = Assessment.player.currQuestion.extra_info_btn_text;
        }
        else {
          extraInfoBtnText = 'View Extra Info';
        }

        $('#' + Assessment.player.currQuestionType + ' .view-extra-info-btn').val ( extraInfoBtnText );

        setTimeout ( function() {
          $('#' + Assessment.player.currQuestionType + ' .view-extra-info-btn').click();
        }, 2000);
      }
      else {
        // - IF NO EXTRA INFO HIDE IT
        $('#' + Assessment.player.currQuestionType + ' .view-extra-info-btn').hide();
      }

      $('#extra-info').hide();
      $('#extra-info-blackout').hide();

      ////////////////
      // - RESET BUTTONS
      ////////////////

      // - HIDE NEXT QUESTION
      $('.next-question-btn').addClass ( 'dn' );

      // - FINISH BUTTON
      $('.finish-quiz-btn').addClass ( 'dn' );
    },



    // - MULTIPLE CHOICE
    MC : {
      load : function() {
        // - LOAD THE MULTIPLE CHOICE QUESTION TYPE

        // - JAVASCRIPT HANDLEBARS TEMPLATE FOR ANSWERS
        var mcAnswerSRC = $('#mc-answers').html(),
            mcAnswerTPL = Handlebars.compile(mcAnswerSRC),
            mcAnswerHTM;

        // - SET THE CURRENT QUESTION'S TYPE
        Assessment.player.currQuestionType = 'multiple-choice';

        // - LOAD COMMON ELEMENTS
        Assessment.player.loadCommonQTypeElements();

        // - GET ALL THE ANSWER ELEMENTS FOR THIS Q IN AN ARRAY
        var answers = Assessment.player.currQuestion.custom.answers;
        var answers_json = {answers:[]};

        // - DETERMINE THE QUESTION SUB TYPE I.E. CAN USER SELECT MORE THAN ONE ANSWER
        // - THIS IS BASED ON HOW MANY ANSWERS ARE SET CORRECT:TRUE
        var answerType = Assessment.player.MC.getAnswerType ( answers );

        // - HTML UL LIST STARTS AS OPENING UL TAG
        var html = '<ul>';

        // - LOOP THROUGH EACH ANSWER
        for(var i = 0; i < answers.length; i++) {
          // - CONVERT TO JSON
          answers_json.answers.push({
            index    : i,
            answer_text  : answers[i].text,
            answerType  : answerType,
          });

          // - ... AND SET IT'S INDEX BASED ON ITERATION
          answers[i].index = i;
        }

        mcAnswerHTM = mcAnswerTPL(answers_json);

        // - RENDER HTML
        $('#multiple-choice .answers').html ( mcAnswerHTM );

        $('#multiple-choice input.answer').off ( 'change' );
        $('#multiple-choice input.answer').on  ( 'change', function ( evt ) {
          var index = Number ( $(this).attr ( 'data-index' ) );
          var type = $(this).attr ( 'type' );

          $('.submit-btn').removeClass ( 'dn' );
          Assessment.player.questionStage = 1;

          if ( type === 'checkbox' ) {
            if ( $(this).prop ( 'checked' ) ) {
              answers[index].selected = true;
            }
            else {
              answers[index].selected = false;
            }
          }
          else {
            $('#multiple-choice input.answer').each ( function ( index, elem ) {
              answers[ $(elem).attr('data-index') ].selected = false;
            });

            if ( $(this).prop ( 'checked' ) ) {
              answers[index].selected = true;
            }
          }

          animateScrollToMax ( '#apollo-content', 1, 0.5 );
        });

        // - APPLY ICHECK FEATURES TO ALL CHECKBOXES AND RADIO BUTTONS
        // $('input[type="checkbox"], input[type="radio"]').iCheck({
        //   checkboxClass: 'icheckbox_flat-orange',
        //   radioClass: 'iradio_flat-orange'
        // });

        // - SET WIDTH OF RADIO
        // $('.iradio_' + skin.iCheckType + '-' + skin.iCheckColor).width(22);

        // - RESET CLICK EVENT OF MULTIPLE CHOICE SUBMIT BUTTON
        $('#multiple-choice .submit-btn').off('click');
        $('#multiple-choice .submit-btn').on('click', function(evt) {

          // - GET ARRAY OF ANSWERS FOR THIS QUESTION
          var answers = Assessment.player.currQuestion.custom.answers;
          var selectedAnswerIndex,// - INDEX INT OF ANSWER WHEN WE LOOP BELOW
            isCorrect,// - THE <answer> TAG'S DESIGNATION
            answeredCorrect = true;//WHETHER THE USER HAS ANSWERED CORRECTLY

          // - LOOP THROUGH ANSWERS
          for ( var i = 0; i < answers.length; i++ ) {
            // - GET ANSWER INDEX
            selectedAnswerIndex = i;
            //console.log('selected:', answers[i].selected, 'correct:', answers[i].correct);
            // - IF SELECTED ANSWER DIFFERS TO CORRECT ANSWER USER GOT IT WRONG
            if ( ( answers[i].selected && answers[i].correct )
              || ( !answers[i].selected && !answers[i].correct )
              || ( answers[i].selected === undefined && !answers[i].correct ) ) {

            }
            else {
              answeredCorrect = false;
              //console.log(answeredCorrect);
            }
          }


          var answerSelected = Assessment.player.MC.anyAnswersSelected();

          if ( answerSelected ) {
            // - IF USER HAS SELECTED AT LEAST ONE ANSWER PROCESS SUBMISSION
            Assessment.player.onSubmit ( answeredCorrect );
          }
          else {
            // - NO ANSWER WAS SELECTED, SHOW PROMPT
            console.log('popup');
            console.log('Please Select an Answer, then click \'Submit\'');
          }

          animateScrollToZero ( '#apollo-content', 1, 0.5 );
        });

        $('.show-explanation-btn').off ( 'click' );
        $('.show-explanation-btn').on  ( 'click', function ( evt ) {
          Assessment.player.questionStage = 3;

          if ( Assessment.player.currQuestion.explanation_dimensions === undefined ) {
            Courses.popup.showDynamicPopup (
              '<h3>Explanation</h3>' +
              Assessment.player.currQuestion.explanation,
              {
                onClose: function() {
                  animateScrollToMax ( '#apollo-content', 1, 0.5 );
                  Assessment.player.questionStage = 4;
                },
              }
            );
          }
          else {
            Courses.popup.showDynamicPopup (
              '<h3>Explanation</h3>' +
              Assessment.player.currQuestion.explanation,
              {
                width: Assessment.player.currQuestion.explanation_dimensions.width,
                height: Assessment.player.currQuestion.explanation_dimensions.height,
                onClose: function() {
                  animateScrollToMax ( '#apollo-content', 1, 0.5 );
                  Assessment.player.questionStage = 4;
                },
              }  
            );
          }

          // console.log(Assessment.player.currQuestionIndex, Assessment.player.questionSet.length - 1, Assessment.player.currQuestionIndex === Assessment.player.questionSet.length - 1);
          if ( Assessment.player.currQuestionIndex === Assessment.player.questionSet.length - 1 ) {
            // - FINISH BUTTON
            $('.finish-quiz-btn').removeClass ( 'dn' );
          }
          else {
            // - AND SHOW NEXT Q BTN
            $('.next-question-btn').removeClass ( 'dn' );
          }
        });

        // - SHOW THE QUESTION TYPE
        $( '#' + Assessment.player.currQuestionType ).show();
      },

      anyAnswersSelected : function ( answers ) {
        var numSelected = 0;

        $('#multiple-choice li input').each(function(i, e) {
          if ( $(e).prop('checked') ) {
            numSelected++;
          }
        });

        return ( numSelected > 0 );
      },

      getAnswerType : function ( answers ) {
        var numCorrect = 0;
        for ( var i = 0; i < answers.length; i++ ) {
          if ( answers[i].correct ) {
            numCorrect++;
          }
        }

        return ( numCorrect > 1 ) ? 'checkbox' : 'radio';
      },
    },



    DITB : {
      dragging : null,
      width : null,

      load : function() {
        // - EMPTY THE QUESTION - IN CASE OF RETAKE
        $('#drag-in-the-blank .answers').html ( '' );

        // - LOAD THE DRAG IN THE BLANK QUESTION TYPE

        // - SET THE CURRENT QUESTION'S TYPE
        Assessment.player.currQuestionType = 'drag-in-the-blank';

        // - LOAD COMMON ELEMENTS
        Assessment.player.loadCommonQTypeElements();

        // - WE WANT THE INSTRUCTIONS AS THE QUESTION HEADER
        $('#drag-in-the-blank .question').html ( Assessment.player.currQuestion.instructions );

        // - ADD IN THE QUESTION TEXT
        $('#drag-in-the-blank .ditb-statement').html ( Assessment.player.currQuestion.text );

        var answerOrderArray = [];
        var answerElems = [];

        // - REPLACE TARGETS
        $('#drag-in-the-blank .ditb-statement .ditb-answer').each ( function ( targetIndex, targetElem ) {
          var randomStrIDSuffix = (Math.random() + 1).toString(36).substring(7);
          answerOrderArray.push ( randomStrIDSuffix );
          //sends to SS script after this loop has added all random strings -  search randomStrAjax

          var answerText = $(targetElem).text();
          $(targetElem).text('');
          $(targetElem).removeClass ( 'ditb-answer' );
          $(targetElem).addClass ( 'ditb-empty' );

          answerElems.push (
            $('<div></div>')
              .attr ( 'id', randomStrIDSuffix )
              .addClass ( 'ditb-answer draggable' )
              .text ( answerText )
              .on ( 'mousedown', function ( evt ) {
                $(this).addClass ( 'dragging' );
                $(this).removeClass ( 'placed' );

                $(this).attr ( 'unselectable', 'on' );

                $(this).css ( 'position', 'absolute' );
                $(this).css ( 'opacity', 0.7 );

                $('*').addClass ( 'no-select' );

                Assessment.player.DITB.droppedOn = null;

                Assessment.player.DITB.dragging = $(this);
                Assessment.player.DITB.offsetX = evt.clientX;
                Assessment.player.DITB.offsetY = evt.clientY;

                $('#drag-in-the-blank').on ( 'mousemove', function ( evt ) {
                  //console.log($(this).offset());
                  //console.log(evt.clientX, evt.clientY);
                  //console.log($(this).offset().left,$(this).offset().top);
                  var dragging = Assessment.player.DITB.dragging;

                  dragging.css ( 'left', evt.pageX - $('#drag-in-the-blank').offset().left - ( dragging.width()/2 ) );
                  dragging.css ( 'top' , evt.pageY - $('#drag-in-the-blank').offset().top - ( dragging.height()/2 ) );

                  //var i = 0;
                  $('#drag-in-the-blank .ditb-statement .ditb-empty').each ( function ( index, elem ) {
                    var dLeft   = Math.round ( dragging.offset().left ),
                        dRight  = Math.round ( dragging.offset().left + dragging.width() ),
                        dTop    = Math.round ( dragging.offset().top ),
                        dBottom = Math.round ( dragging.offset().top + dragging.height() ),
                        tLeft   = Math.round ( $(elem).offset().left ),
                        tRight  = Math.round ( $(elem).offset().left + $(elem).width() ),
                        tTop    = Math.round ( $(elem).offset().top ),
                        tBottom = Math.round ( $(elem).offset().top + $(elem).height() ),

                        xSnapThreshold = 20,
                        ySnapThreshold = 14;

                    Assessment.player.DITB.droppedOn = null;
                    Assessment.player.DITB.dragging
                      .css ( 'opacity', 0.7 );

                    if ( dLeft > tLeft - xSnapThreshold
                         && dRight < tRight + xSnapThreshold
                         && dTop > tTop - ySnapThreshold
                         && dBottom < tBottom + ySnapThreshold ) {
                      Assessment.player.DITB.dragging
                        .css ( 'left', tLeft - $('#drag-in-the-blank').offset().left );
                      Assessment.player.DITB.dragging
                        .css ( 'top', tTop - $('#drag-in-the-blank').offset().top );
                      Assessment.player.DITB.dragging
                        .width ( Assessment.player.DITB.width );
                      Assessment.player.DITB.dragging
                        .css ( 'opacity', 1 );

                      Assessment.player.DITB.droppedOn = $(elem);

                      Assessment.player.DITB.dragging.addClass ( 'placed' );
                      Assessment.player.DITB.dragging.removeClass ( 'dragging' );

                      return false;
                    }
                  });
                });

                $('body').on ( 'mouseup', function ( evt ) {

                  $('*').removeClass ( 'no-select' );

                  $('#drag-in-the-blank').off ( 'mousemove' );

                  if ( Assessment.player.DITB.droppedOn === null ) {
                    Assessment.player.DITB.dragging.css (
                      'top', Assessment.player.DITB.dragging.attr('data-y') + 'px'
                    );

                    Assessment.player.DITB.dragging.css (
                      'left', Assessment.player.DITB.dragging.attr('data-x') + 'px'
                    );

                    Assessment.player.DITB.dragging.width ( 'auto' );

                    Assessment.player.DITB.dragging.css ( 'opacity', 1 );
                  }
                  else {
                    Assessment.player.DITB.droppedOn.attr (
                      'id', 'submitted-' + Assessment.player.DITB.dragging.attr ( 'id' )
                    );
                  }
                });
              })
          );
        });

        // randomStrAjax

        var sendData = {
          questionType : 'ditb',
          correctAnswerData : answerOrderArray
        };

        $.ajax({
          url: '/AJAX-assessment/storeCorrectAnswerObj',
          data: sendData,
          type: 'post',
          dataType: 'json',
          success: function ( returnedData ) {

          }
        });

        // - RESET CLICK EVENT OF DRAG IN THE BLANK SUBMIT BUTTON
        $('#drag-in-the-blank .submit-btn').off('click');
        $('#drag-in-the-blank .submit-btn').on('click', function(evt) {
          // - CHECK ALL PLACED
          if ( $('.ditb-empty').length === $('.placed').length ) {
            // - GET ANSWER OBJ FROM SESSION
            $.ajax({
              url: '/AJAX-assessment/getCorrectAnswerObj',
              dataType: 'json',
              success: function ( returnedData ) {
                var i = 0,
                    answeredCorrect = true;

                // - CHECK CORRECT AND ASSIGN TO answeredCorrect
                $('.ditb-empty').each ( function ( index, elem ) {
                  var rStr = $(elem).attr('id').split('-')[1];

                  if ( returnedData[i] !== rStr ) {
                    answeredCorrect = false;
                  }

                  i++;
                });

                // - SUBMIT
                Assessment.player.onSubmit ( answeredCorrect );
              }
            });
          }
          else {
            // - NOT ALL PLACED
          }
        });

        // - SHOW THE QUESTION TYPE
        $( '#' + Assessment.player.currQuestionType ).show();

        Assessment.player.DITB.checkingIfCanPositionAnswers ( answerElems );
      },

      checkingIfCanPositionAnswers : function ( answerElems ) {
        if ( $('.ditb-statement').outerHeight() > 0 ) {
          Assessment.player.DITB.positionAnswers ( answerElems );
        }
        else {
          setTimeout ( function () {
            Assessment.player.DITB.checkingIfCanPositionAnswers ( answerElems );
          }, 100 );
        }
      },

      positionAnswers : function ( answerElems ) {
        // - RANDOMISE ANSWERS AND ADD THEM
        var shuffledElems = main.shuffle ( answerElems );

        for ( var i = 0; i < shuffledElems.length; i++ ) {
          $('#drag-in-the-blank .answers').append(
            shuffledElems[i]
          );
        }

        // - SET AN EVEN WIDTH FOR EACH DRAGGER
        Assessment.player.DITB.getMaxWidth();

        $('.ditb-empty').each ( function ( index, elem ) {
          $(elem).width ( Assessment.player.DITB.width );
        });

        var left = 20;

        $('#drag-in-the-blank .ditb-answer').each ( function ( index, elem ) {
          $(elem).css ( 'position', 'absolute' );
          $(elem).css ( 'top', ( $('.ditb-statement').outerHeight() + 70 ) + 'px' );
          $(elem).css ( 'left', left + 'px' );

          // - GO THROUGH THE DRAGGERS AND RECORD THEIR ORIGINAL POSITIONS
          $(elem).attr ( 'data-x', left );
          $(elem).attr ( 'data-y', $('.ditb-statement').outerHeight() + 70 );

          left += $(elem).outerWidth() + 20;
        });
      },

      getMaxWidth : function() {
        var width = 0;

        $('div.ditb-answer').each ( function ( index, elem ) {
          width = Math.max ( width, $(elem).outerWidth() );
        });

        Assessment.player.DITB.width = width + 'px';
      },
    },

    FITB : {
      load : function() {
        // - LOAD THE DRAG IN THE BLANK QUESTION TYPE

        // - SET THE CURRENT QUESTION'S TYPE
        Assessment.player.currQuestionType = 'fill-in-the-blank';

        // - LOAD COMMON ELEMENTS
        Assessment.player.loadCommonQTypeElements();

        // - WE WANT THE INSTRUCTIONS AS THE QUESTION HEADER
        $('#fill-in-the-blank .question').html ( Assessment.player.currQuestion.instructions );

        // - ADD IN THE QUESTION TEXT
        $('#fill-in-the-blank .fitb-statement').html ( Assessment.player.currQuestion.text );

        // - ARRAY TO RECORD THE CORRECT ANSWERS
        var answerOrderArray = [];

        var i = 0;
        // - EMPTY THE PLACEHOLDERS AND ADD TEXT INPUTS
        $('#fill-in-the-blank .fitb-answer').each ( function ( index, elem ) {
          answerOrderArray.push ( $(elem).text() );
          $(elem).text('');
          $(elem)
            .append(
              $('<label></label>')
                .attr('for', 'fitb-input-' + i)
                .append(
                  $('<i></i>')
                    .addClass('fa fa-keyboard-o')
                )
            )
            .append(
              $('<input>')
                .attr('type', 'text')
                .attr('id', 'fitb-input-' + i)
                .addClass('fitb-input')
            );

            i++;
        });

        var sendData = {
          questionType : 'fitb',
          correctAnswerData : answerOrderArray
        };

        $.ajax({
          url: '/AJAX-assessment/storeCorrectAnswerObj',
          data: sendData,
          type: 'post',
          dataType: 'json',
          success: function ( returnedData ) {
            // console.log('returnedData',returnedData);

            // - SHOW THE QUESTION TYPE
            $( '#' + Assessment.player.currQuestionType ).show();
          }
        });

        // - RESET CLICK EVENT OF FILL IN THE BLANK SUBMIT BUTTON
        $('#fill-in-the-blank .submit-btn').off('click');
        $('#fill-in-the-blank .submit-btn').on('click', function(evt) {
          // - CHECK ALL FILLED
          var allFilled = true;
          var submittedAnswers = [];

          $('.fitb-answer').each ( function ( index, elem ) {
            submittedAnswers.push ( $(this).find ( '.fitb-input' ).val() );

            if ( $(this).find ( '.fitb-input' ).val().length === 0 ) {
              allFilled = false;
              return false;
            }
          });

          if ( allFilled ) {
            $.ajax({
              url: '/AJAX-assessment/getCorrectAnswerObj',
              dataType: 'json',
              success: function ( returnedData ) {
                var answeredCorrect = true;

                // - CHECK CORRECT AND ASSIGN TO answeredCorrect
                for ( var i = 0; i < returnedData.length; i++ ) {
                  if ( returnedData[i].toLowerCase() !== submittedAnswers[i].toLowerCase() ) {
                    answeredCorrect = false;
                    break;
                  }
                }

                // - SUBMIT
                Assessment.player.onSubmit ( answeredCorrect );
              }
            });
          }
          else {
            // - NOT ALL FILLED

          }

        });
      },
    },

    DAD : {
      load : function() {
        // - EMPTY THE QUESTION - IN CASE IT IS RETAKEN
        $('#drag-and-drop .answers').html ( '' );
        $('#drag-and-drop .dad-categories').html ( '' );

        // - LOAD THE DRAG IN THE BLANK QUESTION TYPE

        var currQuestion = Assessment.player.currQuestion;
        var categories   = currQuestion.custom.categories;

        var sendData = {
          questionType : 'dad',
          correctAnswerData : categories
        };

        $.ajax({
          url: '/AJAX-assessment/storeCorrectAnswerObj',
          data: sendData,
          type: 'post',
          dataType: 'json',
          success: function ( returnedData ) {
            $('#drag-and-drop').show();

            // - SET THE CURRENT QUESTION'S TYPE
            Assessment.player.currQuestionType = 'drag-and-drop';

            // - LOAD COMMON ELEMENTS
            Assessment.player.loadCommonQTypeElements();

            // - WE WANT THE INSTRUCTIONS AS THE QUESTION HEADER
            $('#drag-and-drop .question').html ( Assessment.player.currQuestion.instructions );

            for ( var i = 0; i < categories.length; i++ ) {
              $('#drag-and-drop .dad-categories').append(
                $('<div></div>')
                  .attr ( 'id', 'dad-category-' + i )
                  .attr ( 'data-category-id', i )
                  .addClass ( 'dad-player-category' )
                  .append(
                    $('<header></header>')
                      .append(
                        $('<h4></h4>')
                          .text ( categories[i].name )
                      )
                  )
                  .append(
                    $('<section></section>')
                      .addClass ( 'category-items-host' )
                      .append(
                        $('<header></header>')
                          .append(
                            $('<i></i>')
                              .addClass ( 'fa fa-crosshairs' )
                          )
                          .append(
                            $('<span></span>')
                              .addClass ( 'ml-' )
                              .text ( 'Drop Items Here' )
                          )
                      )
                      .append(
                        $('<ul></ul>')
                      )
                  )
              );
            }// - END FOR

            // - MAKE AN ARRAY OF ITEMS (SHUFFLED)
            Assessment.player.DAD.items = [];

            for ( i = 0; i < categories.length; i++ ) {
              for ( var j = 0; j < categories[i].items.length; j++ ) {
                Assessment.player.DAD.items.push ( categories[i].items[j] );
              }
            }

            Assessment.player.DAD.items = main.shuffle ( Assessment.player.DAD.items );

            Assessment.player.DAD.enterNewItem();

            // - RESET CLICK EVENT OF DRAG IN THE BLANK SUBMIT BUTTON
            $('#drag-and-drop .submit-btn').off('click');
            $('#drag-and-drop .submit-btn').on('click', function(evt) {
              // - CHECK ALL PLACED
              if ( Assessment.player.DAD.items.length === 0 ) {
                // - GET ANSWER OBJ FROM SESSION
                $.ajax({
                  url: '/AJAX-assessment/getCorrectAnswerObj',
                  dataType: 'json',
                  success: function ( returnedData ) {
                    var answeredCorrect = true;

                    // - CHECK CORRECT AND ASSIGN TO answeredCorrect
                    for ( var i = 0; i < returnedData.length; i++ ) {
                      for ( var j = 0; j < returnedData[i].items.length; j++ ) {
                        var liTag = $('#dad-category-' + i + ' ul li')[j];

                        if ( returnedData[i].items.indexOf ( $(liTag).find('span').text() ) === -1 ) {
                          answeredCorrect = false;
                          break;
                        }
                        //console.log($('#dad-category-' + i + ' ul li')[j]);
                        //console.log(returnedData[i].items[j]);
                      }

                    }

                    // - SUBMIT
                    Assessment.player.onSubmit ( answeredCorrect );
                  }
                });
              }
              else {
                // - NOT ALL PLACED
              }
            });
            // - END OF AJAX CALL SUCCESS
          }
        });
      },

      enterNewItem : function() {

        if ( Assessment.player.DAD.items.length > 0 ) {
          Assessment.player.DAD.currItem = Assessment.player.DAD.items[0];

          // - REMOVE IT FROM THE ARRAY
          Assessment.player.DAD.items.splice(0, 1);

          $('#drag-and-drop .answers').append(
            $('<li></li>')
              .addClass ( 'unplaced dad-player-item')
              .attr ( 'style', 'margin-top:-200px;')
              .append(
                $('<i></i>')
                  .addClass ( 'fa fa-hand-o-up rotate-330' )
              )
              .append(
                $('<span></span>')
                  .text ( ' ' + Assessment.player.DAD.currItem )
              )
              .on ( 'mousedown', function ( evt ) {
                $(this).addClass ( 'dragging' );
                $(this).removeClass ( 'placed' );

                $(this).attr ( 'unselectable', 'on' );

                $(this).css ( 'position', 'absolute' );
                $(this).css ( 'opacity', 0.7 );

                $('*').addClass ( 'no-select' );

                Assessment.player.DAD.droppedOn = null;

                Assessment.player.DAD.dragging = $(this);
                Assessment.player.DAD.offsetX = evt.clientX;
                Assessment.player.DAD.offsetY = evt.clientY;

                $(this).css ( 'left', evt.pageX - $('#drag-and-drop').offset().left - ( $(this).width()/2 ) );
                $(this).css ( 'top' , evt.pageY - $('#drag-and-drop').offset().top - ( $(this).height()/2 ) );

                $('#drag-and-drop').on ( 'mousemove', function ( evt ) {
                  //console.log($(this).offset());
                  //console.log(evt.clientX, evt.clientY);
                  //console.log($(this).offset().left,$(this).offset().top);
                  var dragging = Assessment.player.DAD.dragging;
                  dragging.css ( 'left', evt.pageX - $('#drag-and-drop').offset().left - ( dragging.width()/2 ) );
                  dragging.css ( 'top' , evt.pageY - $('#drag-and-drop').offset().top - ( dragging.height()/2 ) );

                  $('#drag-and-drop .category-items-host ul').css ( 'min-height', 'auto' );

                  var i = 0;
                  // console.clear();
                  // console.log($('#drag-and-drop .category-items-host'));
                  $('#drag-and-drop .category-items-host').each ( function ( index, elem ) {
                    var dLeft   = Math.round ( dragging.offset().left ),
                        dRight  = Math.round ( dragging.offset().left + dragging.outerWidth() ),
                        dTop    = Math.round ( dragging.offset().top ),
                        dBottom = Math.round ( dragging.offset().top + dragging.outerHeight() ),
                        tLeft   = Math.round ( $(elem).offset().left ),
                        tRight  = Math.round ( $(elem).offset().left + $(elem).outerWidth() ),
                        tTop    = Math.round ( $(elem).offset().top ),
                        tBottom = Math.round ( $(elem).offset().top + $(elem).outerHeight() ),
                        leftPos,
                        topPos,

                        xSnapThreshold = dragging.outerWidth() / 2,
                        ySnapThreshold = dragging.outerHeight() / 2;

                    // if ( i === 0) {
                    //   console.log(dTop, dRight, dBottom, dLeft);
                    //   console.log(tTop, tRight, tBottom, tLeft);
                    //   console.log('dTop > tTop - ySnapThreshold', dTop, '>', tTop, '-', ySnapThreshold, dTop > tTop - ySnapThreshold);
                    //   console.log('dRight < tRight + xSnapThreshold', dRight, '<', tRight, '+', xSnapThreshold, dRight < tRight + xSnapThreshold);
                    //   console.log('dBottom < tBottom + ySnapThreshold', dBottom, '<', tBottom, '+', ySnapThreshold, dBottom < tBottom + ySnapThreshold);
                    //   console.log('dLeft > tLeft - xSnapThreshold', dLeft, '>', tLeft, '-', xSnapThreshold, dLeft > tLeft - xSnapThreshold);
                    //   i++;
                    // }

                    Assessment.player.DAD.droppedOn = null;
                    Assessment.player.DAD.dragging
                      .css ( 'opacity', 0.7 );

                    if ( dLeft > tLeft - xSnapThreshold
                         && dRight < tRight + xSnapThreshold
                         && dTop > tTop - ySnapThreshold
                         && dBottom < tBottom + ySnapThreshold ) {

                      leftPos = ( tLeft - $('#drag-and-drop').offset().left ) +
                                ( ( (tRight - tLeft) - (dRight - dLeft) ) / 2 );
                      topPos  = ( tTop - $('#drag-and-drop').offset().top ) + 25;

                      Assessment.player.DAD.dragging
                        .css ( 'left', leftPos );
                      Assessment.player.DAD.dragging
                        .css ( 'top', topPos );
                      Assessment.player.DAD.dragging
                        .width ( Assessment.player.DAD.width );
                      Assessment.player.DAD.dragging
                        .css ( 'opacity', 1 );

                      Assessment.player.DAD.droppedOn = $(elem);

                      Assessment.player.DAD.droppedOn.attr (
                        'id', 'submitted-' + Assessment.player.DAD.dragging.attr ( 'id' )
                      );

                      Assessment.player.DAD.droppedOn.find('ul').css ( 'min-height', '40px' );

                      Assessment.player.DAD.dragging.addClass ( 'placed' );
                      Assessment.player.DAD.dragging.removeClass ( 'dragging' );

                      return false;
                    }
                  });
                });

                // - ADD AN ON MOUSE UP TO THE BODY
                $('body').on ( 'mouseup', function ( evt ) {

                  $('*').removeClass ( 'no-select' );

                  $('#drag-and-drop').off ( 'mousemove' );

                  if ( Assessment.player.DAD.droppedOn === null ) {
                    Assessment.player.DAD.dragging.css (
                      'top', Assessment.player.DAD.dragging.attr('data-y') + 'px'
                    );
                    Assessment.player.DAD.dragging.css (
                      'left', Assessment.player.DAD.dragging.attr('data-x') + 'px'
                    );
                    Assessment.player.DAD.dragging.width ( 'auto' );

                    Assessment.player.DAD.dragging.css ( 'opacity', 1 );
                  }
                  else {
                    Assessment.player.DAD.droppedOn.find('ul').css ( 'min-height', 'auto' );

                    Assessment.player.DAD.addItemToCategory (
                      Assessment.player.DAD.droppedOn.parent().attr ( 'data-category-id' ),
                      Assessment.player.DAD.currItem
                    );
                  }

                  $('body').off ( 'mouseup' );
                });
              })

          );

          // - ANIMATE IT IN
          TweenMax.to ( $('.dad-player-item'), 0.6, {'margin-top':0} );
        }
        else {
          // - NO ITEMS LEFT
        }
      },

      addItemToCategory : function ( categoryID, itemName ) {
        $('.dad-player-category[data-category-id="' + categoryID + '"] .category-items-host ul').append(
          $('<li></li>')
            .addClass ( 'dad-added-item' )
            .append(
              $('<span></span>')
                .text ( itemName )
            )
            .append(
              $('<i></i>')
                .addClass ( 'fa fa-close dad-added-item-cross' )
                .on ( 'click', function ( evt ) {
                  Assessment.player.DAD.items.push ( $(this).parent().find('span').text() );

                  if ( Assessment.player.DAD.items.length === 1
                       && $('#drag-and-drop ul.answers li').length === 0 ) {
                    Assessment.player.DAD.enterNewItem();
                  }

                  $(this).parent().remove();
                })
            )

        );

        Assessment.player.DAD.dragging.remove();

        Assessment.player.DAD.enterNewItem();
      },
    },

    skipQuestions : function ( skipHowMany ) {
      for ( var i = 0; i < skipHowMany; i++ ) {
        Assessment.player.onSubmit ( true );
        Assessment.player.nextQuestionBtnClicked();
      }
    },

    loadQuestion : function ( questionSetIndex ) {
      Assessment.player.questionStage = 1;
      // - GET THE QUESTION DATA : AS INDEX SETS (0, 1) IS QUESTION 1 OF SECTION 0
      var question = Assessment.player.questionSet[questionSetIndex];
      // - SET THE CURRENT QUESTION TO THE SELECTED XML TAG
      Assessment.player.currSection = Assessment.data.sections[question.section];
      Assessment.player.currQuestion = Assessment.player.currSection.questions[question.question];

      // - HIDE ALL THE QUESTION TYPES
      $('.question-type').hide();

      // - HIDE SUBMIT
      $('.submit-btn').addClass ( 'dn' );

      // - HIDE EXPLANATION BUTTON
      $('.show-explanation-btn').addClass ( 'dn' );

      switch ( Assessment.player.currQuestion.type ) {
        // - MORE QUESTION TYPES TO BE ADDED

        case 'multiple_choice':
          Assessment.player.MC.load();
          break;

        case 'drag_in_the_blank':
          Assessment.player.DITB.load();
          break;

        case 'fill_in_the_blank':
          Assessment.player.FITB.load();
          break;

        case 'drag_and_drop':
          Assessment.player.DAD.load();
          break;
      }

      // - PREVIOUS QUESTIONS FEEDBACK STYLES REMOVED
      $('.question-type').removeClass ( 'question-answered-correctly' );
      $('.question-type').removeClass ( 'question-answered-incorrectly' );
    },

    /*loadXML : function() {
      var xml_path = $(athena.currSlideXML).attr('xml_path'),// - PATH TO XML FOR CURRENT SLIDE
        ts = new Date();// - TIMESTAMP TO ENSURE XML IS NOT CACHED VERSION

      $.ajax({
        url:'content/' + xml_path + '?ts=' + ts.getTime(),
        dataType:'xml',
        success:function(xml)
        {
          // - SET ASSESSMENT XML
          Assessment.player.xml = xml;

          // - PROCESS EACH SETTING
          Assessment.data.settings = {
            passPercentage : ( $(Assessment.player.xml).find('settings').attr('passPercentage') === 'all' ) ? 'all' : Number ( $(Assessment.player.xml).find('settings').attr('passPercentage') ),
            pickNumFromPool : ( $(Assessment.player.xml).find('settings').attr('pickNumFromPool') === 'all' ) ? 'all' : Number ( $(Assessment.player.xml).find('settings').attr('pickNumFromPool') ),
            pickFromSections : ( $(Assessment.player.xml).find('settings').attr('pickFromSections') === 'true' ) ? true : false,
            shuffleQuestions : ( $(Assessment.player.xml).find('settings').attr('shuffleQuestions') === 'true' ) ? true : false,
            maintainOrderOfSections : ( $(Assessment.player.xml).find('settings').attr('maintainOrderOfSections') === 'true' ) ? true : false,
            includeSectionLabelsInQuestionNumber : ( $(Assessment.player.xml).find('settings').attr('includeSectionLabelsInQuestionNumber') === 'true' ) ? true : false,
            feedbackAfterQuestions : $(Assessment.player.xml).find('settings').attr('feedbackAfterQuestions'),
            feedbackModeAtSummary : $(Assessment.player.xml).find('settings').attr('feedbackModeAtSummary'),
          };

          // - ASSIGNS INDEX VALUES TO EACH SECTION AND QUESTION ELEMENT
          Assessment.player.indexSectionsAndQuestions();

          // - ASSIGNS DEFAULTS SCORES TO EACH QUESTION OF 1 IF NO XML ATTRIBUTE PRESENT
          Assessment.player.setDefaultScores();

          // - EMPTY Q SET
          Assessment.player.questionSet = [];

          // - ALGORITHM TO SELECT WHICH QUESTIONS TO USE, SETTINGS IN XML FOR THIS
          Assessment.player.pickQuestions();

          // - GET TOTAL SCORE
          Assessment.player.totalScore = Assessment.player.getTotalScore();

          // - LOAD FIRST QUESTION
          Assessment.player.currQuestionIndex = 0;
          Assessment.player.loadQuestion ( Assessment.player.currQuestionIndex );

          // - ACTIVATE NEXT BTN
          $('.next-question-btn').on('click', function(evt) {
            Assessment.player.nextQuestionBtnClicked();
          });
        },
        error:function(msg)
        {
          console.log('Error loading assessment xml file.' + JSON.stringify(msg));
        }
      });
    },*/

    // - NEXT BUTTON CLICK EVENT
    nextQuestionBtnClicked : function() {
      console.log(Assessment.player.currQuestionIndex, Assessment.player.questionSet.length - 1, Assessment.player.currQuestionIndex < Assessment.player.questionSet.length - 1);
      if ( Assessment.player.currQuestionIndex < Assessment.player.questionSet.length - 1 ) {
        // - GO TO THE NEXT QUESTION IF THERE ARE ANY REMAINING
        Assessment.player.currQuestionIndex++;
        Assessment.player.loadQuestion ( Assessment.player.currQuestionIndex );
      }
      else {
        // - ELSE FINISHED SO SHOW SUMMARY
        $('.question-type').hide();

        // - SET PASSED TRUE OR FALSE
        Assessment.player.passed = Assessment.player.checkPassed();

        Assessment.player.showSummary();

        Assessment.player.status = ( Assessment.player.passed ) ? 'P' : 'F';

        if ( Assessment.player.passed ) {
          // - RUN THE CUSTOM ON PASSED CALLBACK
          Assessment.player.onPass();
        }

        // - SAVE THE SCORE AND STATUS
        Assessment.player.saveAttempt();
      }
    },

    checkPassed : function() {
      Assessment.player.calculatePercentage();

      return Assessment.player.percentageScore >= Assessment.data.settings.passPercentage;
    },

    saveAttempt : null,

    saveAssessmentAttempt : function() {
      var sendData = {
        assessmentID : Assessment.data.id,
        status       : Assessment.player.status,
        percentage   : Assessment.player.percentageScore,
      };

      $.ajax({
        url: '/ajax/AJAX-assessment/saveAttempt',
        type: 'post',
        data: sendData,
        dataType: 'json',
        success: function ( returnedData ) {
          console.log(returnedData);
        },
      });
    },

    // - SUBMIT CLICK EVENT
    onSubmit : function ( answeredCorrect ) {
      // - ANSWERED CORRECTLY

      if ( answeredCorrect ) {
        // - IF IMMEDIATE FEEDBACK ADD THIS CLASS TO MAKE IT GREEN
        if (  Assessment.data.settings.feedbackAfterQuestions === 'showAnswerStatus' ||
              Assessment.data.settings.feedbackAfterQuestions === 'showAnswer' ) {
          $('.question-type').addClass ( 'question-answered-correctly' );
        }

        // - ADD THE Q'S MARKS TO THE RUNNING SCORE
        var score = +$(Assessment.player.currQuestion).attr('score') || 1;
        Assessment.player.score += score;

        // - SET SCORE
        $(Assessment.player.currQuestion).attr('userScore', $(Assessment.player.currQuestion).attr('score'));

        // - SET STATUS AS CORRECT
        $(Assessment.player.currQuestion).attr('status', 'correct');
      }
      else {
        // - ANSWERED INCORRECTLY
        
        // - IF IMMEDIATE FEEDBACK ADD THIS CLASS TO MAKE IT RED
        if (  Assessment.data.settings.feedbackAfterQuestions === 'showAnswerStatus' ||
              Assessment.data.settings.feedbackAfterQuestions === 'showAnswer' ) {
          $('.question-type').addClass ( 'question-answered-incorrectly' );

          // - HIGHLIGHT THE CORRECT ANSWER
          if ( Assessment.data.settings.feedbackAfterQuestions === 'showAnswer' ) {
            var correctAnswerIdx;
            for ( var i = 0; i < Assessment.player.currQuestion.custom.answers.length; i++ ) {
              if ( Assessment.player.currQuestion.custom.answers[i].correct ) {
                correctAnswerIdx = i; break;
              }
            }

            $($('div.answers li')[correctAnswerIdx]).addClass('showing-correct-answer');
          }
        }

        // - SET SCORE AS 0
        $(Assessment.player.currQuestion).attr('userScore', 0);

        // - SET STATUS AS INCORRECT
        $(Assessment.player.currQuestion).attr('status', 'incorrect');
      }

      // - NOW WE HAVE A SCORE CALCULATE THE PERCENTAGE
      Assessment.player.calculatePercentage();

      // - HIDE SUBMIT...
      $('.submit-btn').addClass('dn');
      if ( Assessment.data.settings.showExplanationsAfterQuestions && Assessment.player.currQuestion.explanation !== '' ) {
        // - AND SHOW FEEDBACK BTN
        $('.show-explanation-btn').removeClass ( 'dn' );
        Assessment.player.questionStage = 2;
      }
      else {
        console.log(Assessment.player.currQuestion.index, Assessment.player.questionSet.length - 1, Assessment.player.currQuestion.index === Assessment.player.questionSet.length - 1);
        if ( Assessment.player.currQuestion.index === Assessment.player.questionSet.length - 1 ) {
          // - FINISH BUTTON
          $('.finish-quiz-btn').removeClass ( 'dn' );
        }
        else {
          // - AND SHOW NEXT Q BTN
          $('.next-question-btn').removeClass ( 'dn' );
        }
      }
    },

    pickQuestions : function() {
      var i = 0,
          pickedQuestion,
          questionPool,
          rIndex,
          questionIndex,
          sectionIndex,
          parentSectionID,
          parentSectionIndex,
          totalQuestionsPicked;

      // - EMPTY THE QUESTION SET
      Assessment.player.questionSet = [];

      // - THIS SETTING IS USED IF YOU HAVE MULTIPLE SECTIONS OF QUESTIONS
      // - AND WANT TO PICK A CERTAIN NUMBER FROM EACH ONE

      if ( Assessment.data.settings.pickFromSections ) {
        // - GET SECTIONS
        var sections = Assessment.data.sections;

        // - LOOP THROUGH SECTIONS, CHECK IT'S PICK NUMBER AND ADD
        // - THAT NUMBER OF QUESTIONS AT RANDOM TO THE QUESTION SET
        for(var s = 0; s < sections.length; s++) {
          // - COUNT OF TOTAL QUESTIONS PICKED SO FAR
          totalQuestionsPicked = 0;

          // - USE A POOL OF QUESTIONS TO PICK FROM
          questionPool = sections[s].questions;

          // - IF WE HAVEN'T PICKED ENOUGH QUESTIONS FOR OUR SET, KEEP PICKING
          while ( totalQuestionsPicked < Number ( $(sections[s]).attr('pickNumFromPool') ) ) {
            // - GET RANDOM INDEX LESS THEN LENGTH OF ARRAY
            rIndex = Math.round ( Math.random() * (questionPool.length - 1) );

            // - USE INDEX TO GET THE QUESTION DATA
            pickedQuestion = questionPool.splice ( rIndex, 1 )[0];

            // - GET THE PARENT SECTION'S INDEX OF THE QUESTION...
            parentSection = $(pickedQuestion).parent();

            // - AND USE IT AS A KIND OF TUPLE OBJECT FOR OUR QUESTION SET
            Assessment.player.questionSet.push ( {section:parentSection.attr('index'), question:$(pickedQuestion).attr('index')} );

            // - UPDATE RUNNING TOTAL OF PICKED QUESTIONS
            totalQuestionsPicked++;
          }
        }
      }
      else { // - NOT PICKING FROM SECTIONS
        // - USE A POOL OF QUESTIONS TO PICK FROM
        questionPool = Assessment.player.getQuestionPool();
        // - IF pickNumFromPool IS all, JUST ADD ALL QUESTIONS TO THE QUESTION SET
        if ( Assessment.data.settings.pickNumFromPool === 0 ) {
          // - IF WE HAVEN'T PICKED ENOUGH QUESTIONS FOR OUR SET, KEEP PICKING
          while ( Assessment.player.questionSet.length < questionPool.length ) {
            // - GET THE QUESTION DATA
            pickedQuestion = questionPool[i++];

            // - GET THE PARENT SECTION'S INDEX OF THE QUESTION...
            parentSectionID    = pickedQuestion.section_id;
            parentSectionIndex = Assessment.player.getSectionIndex ( parentSectionID );

            // - ADD THE Q TO THE SET AS TUPLE-STYLE OBJECT
            questionIndex = Assessment.player.getQuestionIndex (
              parentSectionIndex,
              pickedQuestion.question_id
            );
            Assessment.player.questionSet.push ({
              section  : parentSectionIndex,
              question : questionIndex
            });
          }
        }
        // - ELSE - PICK THE NUMBER OF QUESTIONS IN pickNumFromPool FROM THE WHOLE ASSESSMENT AT RANDOM
        else {
          // - THIS ARRAY IS AN ARRAY OF THE POSSIBLE INDEXES
          // - SO WHEN RANDOMLY PICKING WE CAN REMOVE IT AS A POSSIBLE QUESTION TO AVOID DUPLICATES
          var qPoolIndexes = [];
          var indexesUsed = [];

          for ( var i = 0; i < questionPool.length; i++ ) {
            qPoolIndexes[i] = i;
          }

          // - IF WE HAVEN'T PICKED ENOUGH QUESTIONS FOR OUR SET, KEEP PICKING
          while ( Assessment.player.questionSet.length < Assessment.data.settings.pickNumFromPool ) {
            // - GET RANDOM INDEX LESS THEN LENGTH OF ARRAY
            rIndex = Math.round ( Math.random() * (qPoolIndexes.length - 1) );

            // - GET THE QUESTION DATA
            pickedQuestion = questionPool[qPoolIndexes[rIndex]];

            indexesUsed[indexesUsed.length] = qPoolIndexes.splice(rIndex, 1);

            // - GET THE PARENT SECTION'S INDEX OF THE QUESTION...
            parentSectionID    = pickedQuestion.section_id;
            parentSectionIndex = Assessment.player.getSectionIndex ( parentSectionID );

            // - ADD THE Q TO THE SET AS TUPLE-STYLE OBJECT
            questionIndex  = Assessment.player.getQuestionIndex (
              parentSectionIndex,
              pickedQuestion.question_id
            );

            Assessment.player.questionSet.push ({
              section  : parentSectionIndex,
              question : questionIndex
            });
          }
        }
      }

      // - QUESTIONS HAVE BEEN CHOSEN
      // - NOW SHUFFLE IN THE APPROPRIATE WAY

      if ( Assessment.data.settings.maintainOrderOfSections ) {
        if ( Assessment.data.settings.shuffleQuestions ) {
          // - SHUFFLE THE QUESTIONS BUT KEEP SECTIONS IN ORDER
          Assessment.player.questionSet.sort ( sort_by ( 'section' ) );
        }
        else {
          // - KEEP IN ORDER OF SECTIONS AND QUESTIONS
          Assessment.player.questionSet.sort ( sort_by ( 'section', 'question' ) );
        }
      }
      else {
        // - SHUFFLE THE QUESTIONS SO ANY QUESTION FORM ANY SECTION CAN APPEAR IN ANY ORDER
        Assessment.player.questionSet = main.shuffle ( Assessment.player.questionSet );

        // - THIS COMBINATION OF SETTINGS IS REDUNDANT
        if ( Assessment.data.settings.shuffleQuestions === false )
        {
          console.log('ERROR: keeping questions in order whilst shuffling sections is not a valid mode, so the questions are set to shuffle');
        }
      }
    },

    getQuestionPool : function() {
      var sections  = Assessment.data.sections,
          questions = [];

      for ( var s = 0; s < sections.length; s++ ) {
        for ( var q = 0; q < sections[s].questions.length; q++ ) {
          questions.push ( sections[s].questions[q] );
        }
      }

      return questions;
    },

    getSectionIndex : function ( sectionID ) {
      var output;

      for ( var s = 0; s < Assessment.data.sections.length; s++ ) {
        if ( Assessment.data.sections[s].id == sectionID ) {
          output = s;
          break;
        }
      }

      return output;
    },

    getQuestionIndex : function ( sectionIndex, questionID ) {
      var output,
          questions = Assessment.data.sections[sectionIndex].questions;

      for ( var q = 0; q < questions.length; q++ ) {
        if ( questions[q].question_id == questionID ) {
          output = q;
          break;
        }
      }

      return output;
    },

    setDefaultScores : function() {
      var possible_marks;
      var sections = Assessment.data.sections;

      // - LOOP THROUGH EACH SECTION...
      for(var s = 0; s < sections.length; s++) {
        // - GET ITS QUESTIONS...
        var questions = sections[s].questions;

        // - LOOP THROUGH THE QUESTIONS
        for(var q = 0; q < questions.length; q++) {
          // - GET THE SCORE IF THERE IS ONE, IF NOT SET AS 1
          possible_marks = ( questions[q].possible_marks === undefined ) ? 1 : Number ( questions[q].possible_marks );
          questions[q].possible_marks = possible_marks;
        }
      }
    },

    showScoreAndListAnswerStatuses : function() {
      // - THIS FEEDBACK METHOD SHOWS THE SCORE & EACH ANSWER IN A TABULAR LIST

        // - QUESTION XML DATA
      var  question,
        // - SECTION AND QUESTION REF I.E. A1 OR B8
        questionDesignation,
        // - USED TO DETERMINE IF ALL QUESTIONS ARE WORTH ONE MARK: NO MARK COLUMN IS SHOWN IF ANY ARE != 1 IT SHOWS MARKS
        complexMarking = false,
        // - THE COLSPAN OF THE MORE INFO ROWS NEED TO BE DIFFERENT DEPENDING ON WHETHER WE SHOW MARKS
        colspan,
        // - STATUS TO SHOW TICK OR CROSS
        statusImage,
        // - JS TPL
        summary_src = $('script#showScoreAndListAnswerStatuses').html(),
        summaryTPL = Handlebars.compile ( summary_src ),
        summaryHTM;

      for(var i = 0; i < Assessment.player.questionSet.length; i++) {
        // - LOOPS THROUGH QUESTIONS, IF ANY ARE != 1 WE'LL SHOW MARKS LATER ON
        question = $(Assessment.player.xml)
              .find('section[index="' + Assessment.player.questionSet[i].section + '"]')
              .find('question[index="' + Assessment.player.questionSet[i].question + '"]');

        if ( $(question).attr('score') !== '1' ) {
          complexMarking = true;
          break;
        }
      }

      var summaryJSON = {
        passed            : Assessment.player.passed,
        complexMarking    : complexMarking,
        // skin              : Athena.skin,
        questions         : [],
      };

      // - DETERMINE OPENING TAG CONTENT
      if ( Assessment.player.passed ) {
        summaryJSON.passFailClass = 'passed';
        summaryJSON.passFailContent = 'Congratulations, you passed this assessment';
      }
      else {
        summaryJSON.passFailClass = 'failed';
        summaryJSON.passFailContent = 'Sorry, unfortunately you haven\'t passed this time around.';
      }

      for ( i = 0; i < Assessment.player.questionSet.length; i++ ) {
        // - LOOPS THROUGH QUESTION SET

        // - GET QUESTION XML DATA
        question = $(Assessment.player.xml)
              .find('section[index="' + Assessment.player.questionSet[i].section + '"]')
              .find('question[index="' + Assessment.player.questionSet[i].question + '"]');

        questionDesignation = $(question).parent().attr('label') + $(question).attr('number');

        statusImage = ( $(question).attr('status') === 'correct' ) ? 'tick.png' : 'cross.png';

        colspan = ( complexMarking ) ? 4 : 3;

        // - JSON Q MODEL
        summaryJSON.questions.push({
          section : Assessment.player.questionSet[i].section,
          question : Assessment.player.questionSet[i].question,
          questionDesignation : questionDesignation,
          statusImage : statusImage,
          questionText : $(question).find('question_text').html(),
          userScore : $(question).attr('userScore'),
          complexMarking : complexMarking,
          score : $(question).attr('score'),
          colspan : colspan,
        });
      }

      // - CREATE HTML FROM TEMPLATE AND SET
      summaryHTM = summaryTPL ( summaryJSON );

      $('#summary .summary-body').height(380);
      $('#summary .summary-body').html ( summaryHTM );

      $('#summary').show();

      // - TWEENS THE PERCENTAGE BAR FROM 0 TO WIDTH OF SCORE
      TweenMax.to( $('#summary .summary-body .percentage-bar') , 2, {
        width    :  Assessment.player.percentageScore + '%',
        onUpdate  :  function() {
                  var perc = Math.round ( $('#summary .summary-body .percentage-bar').width() / $('#summary .summary-body .percentage-barBG').width() * 100 );
                  $('#summary .summary-body .percentageNumber').html ( perc + '%' );
                },
        delay    :  1
      });
    },

    showScoreAndListAnswers : function ( showCorrectAnswersIfWrong, showFeedback ) {
      // - QUESTION XML DATA
      var  question,
        // - SECTION AND QUESTION REF I.E. A1 OR B8
        questionDesignation,
        // - USED TO DETERMINE IF ALL QUESTIONS ARE WORTH ONE MARK: NO MARK COLUMN IS SHOWN IF ANY ARE != 1 IT SHOWS MARKS
        complexMarking = false,
        // - THE COLSPAN OF THE MORE INFO ROWS NEED TO BE DIFFERENT DEPENDING ON WHETHER WE SHOW MARKS
        colspan,
        // - STATUS TO SHOW TICK OR CROSS
        statusImage,
        // - JS TPL
        summary_src = $('script#showScoreAndListAnswers').html(),
        summaryTPL = Handlebars.compile ( summary_src ),
        summaryHTM;

      for(var i = 0; i < Assessment.player.questionSet.length; i++) {
        // - LOOPS THROUGH QUESTIONS, IF ANY ARE != 1 WE'LL SHOW MARKS LATER ON
        question = $(Assessment.player.xml)
              .find('section[index="' + Assessment.player.questionSet[i].section + '"]')
              .find('question[index="' + Assessment.player.questionSet[i].question + '"]');

        if ( $(question).attr('score') !== '1' ) {
          complexMarking = true;
          break;
        }
      }

      var summaryJSON = {
        passed            : Assessment.player.passed,
        complexMarking    : complexMarking,
        skin              : Athena.skin,
        questions          : [],
      };

      // - DETERMINE OPENING TAG CONTENT
      if ( Assessment.player.passed ) {
        summaryJSON.passFailClass = 'passed';
        summaryJSON.passFailContent = 'Congratulations, you passed this assessment';
      }
      else {
        summaryJSON.passFailClass = 'failed';
        summaryJSON.passFailContent = 'Sorry, unfortunately you haven\'t passed this time around.';
      }

      for(i = 0; i < Assessment.player.questionSet.length; i++) {
        // - LOOPS THROUGH QUESTION SET

        // - GET QUESTION XML DATA
        question = $(Assessment.player.xml)
              .find('section[index="' + Assessment.player.questionSet[i].section + '"]')
              .find('question[index="' + Assessment.player.questionSet[i].question + '"]');

        questionDesignation = $(question).parent().attr('label') + $(question).attr('number');

        statusImage = ( $(question).attr('status') === 'correct' ) ? 'tick.png' : 'cross.png';

        colspan = ( complexMarking ) ? 5 : 4;

        // - JSON Q MODEL
        summaryJSON.questions.push({
          section : Assessment.player.questionSet[i].section,
          question : Assessment.player.questionSet[i].question,
          questionDesignation : questionDesignation,
          statusImage : statusImage,
          questionText : $(question).find('question_text').text(),
          userScore : $(question).attr('userScore'),
          complexMarking : complexMarking,
          score : $(question).attr('score'),
          colspan : colspan,
        });
      }

      // - CREATE HTML FROM TEMPLATE AND SET
      summaryHTM = summaryTPL ( summaryJSON );
      //console.log(summaryJSON);

      $('#summary .summary-body').height(380);
      $('#summary .summary-body').html ( summaryHTM );

      $('#summary').show();

      $('.summary_show_feedback_btn').on('click', function(evt) {
        // - GET SECTION ID AND QUESTION ID
        var expandingSection  = $(this).parent().parent().attr('data-section-id'),
          expandingQuestion  = $(this).parent().parent().attr('data-question-id'),
          // - TEMP VARIABLE FOR THE CLICKED LINK
          moreLink = $(this),
          // - TEMP VAR FOR THE TD TAG THAT EXPANDS
          td = $('.summary_more_info[data-section-id="' + expandingSection + '"][data-question-id="' + expandingQuestion + '"] td'),
          // - TEMP VAR FOR THE FEEDBACK CONTAINER DIV
          feedback = $('.summary_more_info[data-section-id="' + expandingSection + '"][data-question-id="' + expandingQuestion + '"] td .summary_feedback');

        // - IF IT'S CLOSED
        if ( $(this).html() === 'More' ) {
          // - WE GET THE WIDTH BY COPYING THE HTML INTO A SANDBOX
          // - THEN SIMPLY GET A VERTICAL MEASURE OF THE BOX WHEN POPULATED
          // - THIS WAY IT WILL ALWAYS MEASURE CORRECTLY
          var feedback_width = $('.summary_more_info').width();
          $('#content_sandbox').width ( feedback_width );
          $('#content_sandbox').html ( Assessment.player.getSummaryFeedback ( expandingSection, expandingQuestion, showCorrectAnswersIfWrong, showFeedback ) );
          // - WE NOW HAVE THE HEIGHT WE WANT TO TWEEN TO
          var feedbackHeight = $('#content_sandbox').height();

          TweenMax.to ( td, 0.5, {
            height : feedbackHeight,
            paddingTop : '10px',
            paddingBottom : '10px',
            onComplete : function() {
              feedback.html ( $('#content_sandbox').html() );
              $('#content_sandbox').html('');
              TweenMax.to ( feedback, 0.5, {
                opacity : 1
              });
              // - CHANGE THE LINK TEXT TO LESS SO IT TOGGLES
              moreLink.html ( 'Less' );
            }
          });
        }
        // - IF IT'S OPEN
        else {
          // - JUST TWEEN IT BACK TO 0 HEIGHT SO IT DISAPPEARS
          TweenMax.to ( feedback, 0.5, {
            opacity : 0,
            onComplete : function() {
              feedback.html('');
              TweenMax.to ( td, 0.5, {
                height : 0,
                paddingTop : 0,
                paddingBottom : 0,
                onComplete : function() {
                  moreLink.html ( 'More' );
                }
              });
            }
          });
        }
      });

      // - TWEENS THE PERCENTAGE BAR FROM 0 TO WIDTH OF SCORE
      TweenMax.to( $('#summary .summary-body .percentage-bar') , 2, {
        width    :  Assessment.player.percentageScore + '%',
        onUpdate  :  function() {
                  var perc = Math.round ( $('#summary .summary-body .percentage-bar').width() / $('#summary .summary-body .percentage-barBG').width() * 100 );
                  $('#summary .summary-body .percentageNumber').html ( perc + '%' );
                },
        delay    :  1
      });
    },

    notScored : function() {
      var
      // - JS TPL
      notScoredSRC = $('script#notScored').html(),
      notScoredTPL = Handlebars.compile ( notScoredSRC ),
      notScoredHTM = notScoredTPL();

      $('#summary .summary-body').height(250);
      $('#summary .summary-body').html ( notScoredHTM );
      $('#summary').show();
      
      // - TWEENS THE PERCENTAGE BAR FROM 0 TO WIDTH OF SCORE
      TweenMax.to( $('#summary .summary-body .percentageBar') , 2, {
        width : Assessment.player.percentageScore + '%',
        onUpdate : function() {
          var perc = Math.round ( $('#summary .summary-body .percentageBar').width() / $('#summary .summary-body .percentageBarBG').width() * 100 );
          $('#summary .summary-body .percentageNumber').html ( perc + '%' );
        },
        delay : 1
      });
    },

    getSummaryFeedback : function ( section, question, showCorrectAnswersIfWrong, showFeedback ) {
      var i,
          question = $(Assessment.player.xml).find('section[index="' + section + '"]').find('question[index="' + question + '"]'),
          multi_choice_labels = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'];

      // - WHICH TYPE OF QUESTION ARE WE DEALING WITH
      switch ( $(question).attr('type') ) {
        case 'multiple_choice':

          var answers = $(question).find('answer'),
            answer,
            output = '<table><tr><td>No.</td><td></td><td>Your Answer</td><td>Correct Answer</td></tr>',
            tr;

          if ( showCorrectAnswersIfWrong ) {
            for(i = 0; i < answers.length; i++) {
              answer =  '<td>' + multi_choice_labels[i] + '</td>' +
                  '<td>' + $(answers[i]).html() + '</td>';

              // - IF CORRECT GIVE CORRECT CLASS
              if ( $(answers[i]).attr('correct') === 'true' )
                tr = '<tr class="answer-fb-correct">';
              // - IF INCORRECT GIVE INCORRECT CLASS
              else if ( $(answers[i]).attr('correct') === 'false' )
                tr = '<tr class="answer-fb-correct">';
              // - IF IT'S AN INCORRECT ANSWER BUT WASN'T GIVEN IT WILL BE GRAYED OUT IN THE NEXT LOGIC BLOCK

              if ( $(answers[i]).attr('selected') === 'true' )
                answer += '<td><input type="checkbox" checked disabled></td>';
              else
                answer += '<td><input type="checkbox" disabled></td>';

              if ( $(answers[i]).attr('correct') === 'true' )
                answer += '<td><input type="checkbox" checked disabled></td>';
              else
                answer += '<td><input type="checkbox" disabled></td>';

              output += tr + answer + '</tr>';
            }

            output += '</table>';
          }

          break;
      }

      if ( showFeedback )
        output += '<div class="answer-fb"><h3>FEEDBACK</h3>' + $(question).find('feedback').html() + '</div>';

      return output;
    },

    showScoreOnly : function() {
      var summarySRC = $('script#show-score-only-tpl').html(),
          summaryTPL = Handlebars.compile ( summarySRC ),
          summaryHTM;

      var tplData = {
        passed : Assessment.player.passed,
        showCloseBtnAfterComplete : Assessment.data.settings.showCloseBtnAfterComplete,
        showCustomMessageAfterComplete : Assessment.data.settings.showCustomMessageAfterComplete,
        customMessageAfterComplete : Assessment.data.settings.customMessageAfterComplete,
      };

      summaryHTM = summaryTPL ( tplData );

      $('#summary .summary-body').html ( summaryHTM );

      $('#summary').show();

      $('#retake-assessment-btn').off ( 'click' );
      $('#retake-assessment-btn').on  ( 'click', function ( evt ) {
        // Assessment.player.loadAssessment ( Assessment.player.assessmentID, Assessment.player.saveAttempt );
        Courses.content.loadSlide (
          Courses.currentCourse.currentSectionIdx,
          Courses.currentCourse.currentSlideIdx,
          '#current-slide',
          function(){
            console.log('retake');
          }
        );
      });

      $('#close-athena-after-assessment-btn').off ( 'click' );
      $('#close-athena-after-assessment-btn').on  ( 'click', function ( evt ) {
        popup.close();

        TweenMax.delayedCall ( 0.25, function() {
          window.location.href = window.location.href;
        });
      });

      TweenMax.to( $('#summary .summary-body .percentage-fill') , 2, {
        width :  Assessment.player.percentageScore + '%',
        onUpdate : function() {
          var fillWidth = $('#summary .summary-body .percentage-fill').width();
          var fullWidth = $('#summary .summary-body .percentage-bar').width();
          var perc = Math.round ( fillWidth / fullWidth * 100 );
          $('#summary .summary-body .percentage-text').html ( perc + '%' );
        },
        delay :  1
      });
    },

    showSummary : function() {
      $('#next-btn').off ( 'click.assessment-next' );
      Courses.footerNav.enableNavBtns();
      switch ( Assessment.data.settings.feedbackModeAtSummary ) {
        case 0:
          Assessment.player.showScoreOnly();
          break;

        case 1:
          Assessment.player.showScoreAndListAnswerStatuses();
          break;

        case 2:
          Assessment.player.showScoreAndListAnswers(true, false);
          break;

        case 3:
          Assessment.player.showScoreAndListAnswers(true, true);
          break;

        case 4:
          Assessment.player.notScored();
          break;

      }
    },

    viewExtraInfo : function() {
      Courses.popup.showDynamicPopup (
        Assessment.player.currQuestion.extra_info_content,
        {
          width: '800px',
          height: '300px',
        }
      );
      // $('#extra-info').show();
      // $('#extra-info-blackout').show();

      // TweenMax.to ( '#extra-info', 0.3, {
      //   top: '50%',
      // });
    },

  },
};
